'use client';
import * as React from 'react';
import React__default, { useEffect, useLayoutEffect, useRef, useState, forwardRef, Fragment, isValidElement, cloneElement, createElement, createContext, useContext, useMemo, useReducer, createRef, useCallback } from 'react';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import { Link as Link$1 } from 'react-router-dom';
import { ThemeContext } from '../Theme';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var i$2=Object.defineProperty;var d$2=(t,e,n)=>e in t?i$2(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r$1=(t,e,n)=>(d$2(t,typeof e!="symbol"?e+"":e,n),n);let o$4 = class o{constructor(){r$1(this,"current",this.detect());r$1(this,"handoffState","pending");r$1(this,"currentId",0);}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e);}reset(){this.set(this.detect());}nextId(){return ++this.currentId}get isServer(){return this.current==="server"}get isClient(){return this.current==="client"}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client"}handoff(){this.handoffState==="pending"&&(this.handoffState="complete");}get isHandoffComplete(){return this.handoffState==="complete"}};let s$6=new o$4;

let l$3=(e,f)=>{s$6.isServer?useEffect(e,f):useLayoutEffect(e,f);};

function s$5(e){let r=useRef(e);return l$3(()=>{r.current=e;},[e]),r}

function t$2(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}));}

function o$3(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return t$2(()=>{t.current&&e[0]();}),r.add(()=>{t.current=!1;})},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a});})},group(e){let t=o$3();return e(t),this.add(()=>t.dispose())},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s();}},dispose(){for(let e of n.splice(0))e();}};return r}

function p$1(){let[e]=useState(o$3);return useEffect(()=>()=>e.dispose(),[e]),e}

let o$2=function(t){let e=s$5(t);return React__default.useCallback((...r)=>e.current(...r),[e])};

function s$4(){let r=typeof document=="undefined";return "useSyncExternalStore"in React?(o=>o.useSyncExternalStore)(React)(()=>()=>{},()=>!1,()=>!r):!1}function l$2(){let r=s$4(),[e,n]=React.useState(s$6.isHandoffComplete);return e&&s$6.isHandoffComplete===!1&&n(!1),React.useEffect(()=>{e!==!0&&n(!0);},[e]),React.useEffect(()=>s$6.handoff(),[]),r?!1:e}

var o$1;let I$2=(o$1=React__default.useId)!=null?o$1:function(){let n=l$2(),[e,u]=React__default.useState(n?()=>s$6.nextId():null);return l$3(()=>{e===null&&u(s$6.nextId());},[e]),e!=null?""+e:void 0};

function u$1(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u$1),t}

function e$1(r){return s$6.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document}

let c$5=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var M$3=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(M$3||{}),N$2=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(N$2||{}),F$1=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(F$1||{});function f$2(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(c$5)).sort((r,t)=>Math.sign((r.tabIndex||Number.MAX_SAFE_INTEGER)-(t.tabIndex||Number.MAX_SAFE_INTEGER)))}var T$1=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T$1||{});function h$1(e,r=0){var t;return e===((t=e$1(e))==null?void 0:t.body)?!1:u$1(r,{[0](){return e.matches(c$5)},[1](){let l=e;for(;l!==null;){if(l.matches(c$5))return !0;l=l.parentElement;}return !1}})}var w$2=(t=>(t[t.Keyboard=0]="Keyboard",t[t.Mouse=1]="Mouse",t))(w$2||{});typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("keydown",e=>{e.metaKey||e.altKey||e.ctrlKey||(document.documentElement.dataset.headlessuiFocusVisible="");},!0),document.addEventListener("click",e=>{e.detail===1?delete document.documentElement.dataset.headlessuiFocusVisible:e.detail===0&&(document.documentElement.dataset.headlessuiFocusVisible="");},!0));let S$3=["textarea","input"].join(",");function H$1(e){var r,t;return (t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,S$3))!=null?t:!1}function I$1(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),i=r(l);if(o===null||i===null)return 0;let n=o.compareDocumentPosition(i);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function O(e,r,{sorted:t=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?I$1(e):e:f$2(e);o.length>0&&n.length>1&&(n=n.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let E=(()=>{if(r&5)return 1;if(r&10)return -1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(l))-1;if(r&4)return Math.max(0,n.indexOf(l))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),p=r&32?{preventScroll:!0}:{},d=0,a=n.length,u;do{if(d>=a||d+a<=0)return 0;let s=x+d;if(r&16)s=(s+a)%a;else {if(s<0)return 3;if(s>=a)return 1}u=n[s],u==null||u.focus(p),d+=E;}while(u!==i.activeElement);return r&6&&H$1(u)&&u.select(),2}

function d$1(e,r,n){let o=s$5(r);useEffect(()=>{function t(u){o.current(u);}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n]);}

function s$3(e,r,n){let o=s$5(r);useEffect(()=>{function t(i){o.current(i);}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n]);}

function h(s,m,a=!0){let i=useRef(!1);useEffect(()=>{requestAnimationFrame(()=>{i.current=a;});},[a]);function c(e,r){if(!i.current||e.defaultPrevented)return;let t=r(e);if(t===null||!t.getRootNode().contains(t)||!t.isConnected)return;let E=function u(n){return typeof n=="function"?u(n()):Array.isArray(n)||n instanceof Set?n:[n]}(s);for(let u of E){if(u===null)continue;let n=u instanceof HTMLElement?u:u.current;if(n!=null&&n.contains(t)||e.composed&&e.composedPath().includes(n))return}return !h$1(t,T$1.Loose)&&t.tabIndex!==-1&&e.preventDefault(),m(e,t)}let o=useRef(null);d$1("pointerdown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target);},!0),d$1("mousedown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target);},!0),d$1("click",e=>{o.current&&(c(e,()=>o.current),o.current=null);},!0),d$1("touchend",e=>c(e,()=>e.target instanceof HTMLElement?e.target:null),!0),s$3("blur",e=>c(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0);}

function i$1(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return "button"}function s$2(t,e){let[n,u]=useState(()=>i$1(t));return l$3(()=>{u(i$1(t));},[t.type,t.as]),l$3(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button");},[n,e]),n}

let u=Symbol();function T(t,n=!0){return Object.assign(t,{[u]:n})}function y$1(...t){let n=useRef(t);useEffect(()=>{n.current=t;},[t]);let c=o$2(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e);});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}

function t$1(...r){return Array.from(new Set(r.flatMap(n=>typeof n=="string"?n.split(" "):[]))).filter(Boolean).join(" ")}

var S$2=(a=>(a[a.None=0]="None",a[a.RenderStrategy=1]="RenderStrategy",a[a.Static=2]="Static",a))(S$2||{}),j$2=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(j$2||{});function X({ourProps:r,theirProps:t,slot:e,defaultTag:a,features:s,visible:n=!0,name:f}){let o=N$1(t,r);if(n)return c$4(o,e,a,f);let u=s!=null?s:0;if(u&2){let{static:l=!1,...p}=o;if(l)return c$4(p,e,a,f)}if(u&1){let{unmount:l=!0,...p}=o;return u$1(l?0:1,{[0](){return null},[1](){return c$4({...p,hidden:!0,style:{display:"none"}},e,a,f)}})}return c$4(o,e,a,f)}function c$4(r,t={},e,a){let{as:s=e,children:n,refName:f="ref",...o}=g$1(r,["unmount","static"]),u=r.ref!==void 0?{[f]:r.ref}:{},l=typeof n=="function"?n(t):n;"className"in o&&o.className&&typeof o.className=="function"&&(o.className=o.className(t));let p={};if(t){let i=!1,m=[];for(let[y,d]of Object.entries(t))typeof d=="boolean"&&(i=!0),d===!0&&m.push(y);i&&(p["data-headlessui-state"]=m.join(" "));}if(s===Fragment&&Object.keys(R(o)).length>0){if(!isValidElement(l)||Array.isArray(l)&&l.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${a} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(o).map(d=>`  - ${d}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(d=>`  - ${d}`).join(`
`)].join(`
`));let i=l.props,m=typeof(i==null?void 0:i.className)=="function"?(...d)=>t$1(i==null?void 0:i.className(...d),o.className):t$1(i==null?void 0:i.className,o.className),y=m?{className:m}:{};return cloneElement(l,Object.assign({},N$1(l.props,R(g$1(o,["ref"]))),p,u,w$1(l.ref,u.ref),y))}return createElement(s,Object.assign({},g$1(o,["ref"]),s!==Fragment&&u,s!==Fragment&&p),l)}function w$1(...r){return {ref:r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t);}}}function N$1(...r){if(r.length===0)return {};if(r.length===1)return r[0];let t={},e={};for(let s of r)for(let n in s)n.startsWith("on")&&typeof s[n]=="function"?((e[n])!=null||(e[n]=[]),e[n].push(s[n])):t[n]=s[n];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(s=>[s,void 0])));for(let s in e)Object.assign(t,{[s](n,...f){let o=e[s];for(let u of o){if((n instanceof Event||(n==null?void 0:n.nativeEvent)instanceof Event)&&n.defaultPrevented)return;u(n,...f);}}});return t}function D$1(r){var t;return Object.assign(forwardRef(r),{displayName:(t=r.displayName)!=null?t:r.name})}function R(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function g$1(r,t=[]){let e=Object.assign({},r);for(let a of t)a in e&&delete e[a];return e}

function r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i(l)?!1:t}function i(n){if(!n)return !1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return !1;e=e.previousElementSibling;}return !0}

let a$1="div";var p=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(p||{});function s$1(t,o){let{features:n=1,...e}=t,d={ref:o,"aria-hidden":(n&2)===2?!0:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(n&4)===4&&(n&2)!==2&&{display:"none"}}};return X({ourProps:d,theirProps:e,slot:{},defaultTag:a$1,name:"Hidden"})}let c$3=D$1(s$1);

let n$2=createContext(null);n$2.displayName="OpenClosedContext";var d=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(d||{});function C(){return useContext(n$2)}function c$2({value:o,children:r}){return React__default.createElement(n$2.Provider,{value:o},r)}

var o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o||{});

function n$1(...e){return useMemo(()=>e$1(...e),[...e])}

var s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(s||{});function n(){let e=useRef(0);return s$3("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0);},!0),e}

function f$1(){let e=useRef(!1);return l$3(()=>(e.current=!0,()=>{e.current=!1;}),[]),e}

function E$1(n,e,a,t){let i=s$5(a);useEffect(()=>{n=n!=null?n:window;function r(o){i.current(o);}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t]);}

function c$1(t){let r=o$2(t),e=useRef(!1);useEffect(()=>(e.current=!1,()=>{e.current=!0,t$2(()=>{e.current&&r();});}),[r]);}

let e=createContext(!1);function l$1(){return useContext(e)}

function F(p){let l=l$1(),n=useContext(v$2),e=n$1(p),[a,o]=useState(()=>{if(!l&&n!==null||s$6.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return useEffect(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a));},[a,e]),useEffect(()=>{l||n!==null&&o(n.current);},[n,o,l]),a}let U$1=Fragment;function N(p,l){let n=p,e=useRef(null),a=y$1(T(u=>{e.current=u;}),l),o=n$1(e),t=F(e),[r]=useState(()=>{var u;return s$6.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null}),i=useContext(f),C=l$2();return l$3(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r));},[t,r]),l$3(()=>{if(r&&i)return i.register(r)},[i,r]),c$1(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)));}),C?!t||!r?null:createPortal(X({ourProps:{ref:a},theirProps:n,defaultTag:U$1,name:"Portal"}),r):null}let S$1=Fragment,v$2=createContext(null);function j$1(p,l){let{target:n,...e}=p,o={ref:y$1(l)};return React__default.createElement(v$2.Provider,{value:n},X({ourProps:o,theirProps:e,defaultTag:S$1,name:"Popover.Group"}))}let f=createContext(null);function ae$1(){let p=useContext(f),l=useRef([]),n=o$2(o=>(l.current.push(o),p&&p.register(o),()=>e(o))),e=o$2(o=>{let t=l.current.indexOf(o);t!==-1&&l.current.splice(t,1),p&&p.unregister(o);}),a=useMemo(()=>({register:n,unregister:e,portals:l}),[n,e,l]);return [l,useMemo(()=>function({children:t}){return React__default.createElement(f.Provider,{value:a},t)},[a])]}let D=D$1(N),I=D$1(j$1);Object.assign(D,{Group:I});

function j({defaultContainers:t=[],portals:r,mainTreeNodeRef:u}={}){var c;let o=useRef((c=u==null?void 0:u.current)!=null?c:null),l=n$1(o),f=o$2(()=>{var i;let n=[];for(let e of t)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(r!=null&&r.current)for(let e of r.current)n.push(e);for(let e of (i=l==null?void 0:l.querySelectorAll("html > *, body > *"))!=null?i:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(o.current)||n.some(T=>e.contains(T))||n.push(e));return n});return {resolveContainers:f,contains:o$2(n=>f().some(i=>i.contains(n))),mainTreeNodeRef:o,MainTreeNode:useMemo(()=>function(){return u!=null?null:React__default.createElement(c$3,{features:p.Hidden,ref:o})},[o,u])}}function y(){let t=useRef(null);return {mainTreeNodeRef:t,MainTreeNode:useMemo(()=>function(){return React__default.createElement(c$3,{features:p.Hidden,ref:t})},[t])}}

var t;let a=(t=React__default.startTransition)!=null?t:function(i){i();};

var q=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(q||{}),z=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(z||{});let Q={[0]:e=>({...e,disclosureState:u$1(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},k=createContext(null);k.displayName="DisclosureContext";function M$2(e){let n=useContext(k);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,M$2),o}return n}let v$1=createContext(null);v$1.displayName="DisclosureAPIContext";function w(e){let n=useContext(v$1);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,w),o}return n}let H=createContext(null);H.displayName="DisclosurePanelContext";function V(){return useContext(H)}function Y(e,n){return u$1(n.type,Q,e,n)}let Z=Fragment;function ee(e,n){let{defaultOpen:o=!1,...u}=e,T$1=useRef(null),l=y$1(n,T(a=>{T$1.current=a;},e.as===void 0||e.as===Fragment)),t=useRef(null),f=useRef(null),s=useReducer(Y,{disclosureState:o?0:1,linkedPanel:!1,buttonRef:f,panelRef:t,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:c},D]=s,d$1=o$2(a=>{D({type:1});let r=e$1(T$1);if(!r||!c)return;let p=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(c):r.getElementById(c))();p==null||p.focus();}),P=useMemo(()=>({close:d$1}),[d$1]),b=useMemo(()=>({open:i===0,close:d$1}),[i,d$1]),y={ref:l};return React__default.createElement(k.Provider,{value:s},React__default.createElement(v$1.Provider,{value:P},React__default.createElement(c$2,{value:u$1(i,{[0]:d.Open,[1]:d.Closed})},X({ourProps:y,theirProps:u,slot:b,defaultTag:Z,name:"Disclosure"}))))}let te="button";function ne(e,n){let o$1=I$2(),{id:u=`headlessui-disclosure-button-${o$1}`,...T}=e,[l,t]=M$2("Disclosure.Button"),f=V(),s=f===null?!1:f===l.panelId,i=useRef(null),c=y$1(i,n,s?null:l.buttonRef);useEffect(()=>{if(!s)return t({type:2,buttonId:u}),()=>{t({type:2,buttonId:null});}},[u,t,s]);let D=o$2(r=>{var p;if(s){if(l.disclosureState===1)return;switch(r.key){case o.Space:case o.Enter:r.preventDefault(),r.stopPropagation(),t({type:0}),(p=l.buttonRef.current)==null||p.focus();break}}else switch(r.key){case o.Space:case o.Enter:r.preventDefault(),r.stopPropagation(),t({type:0});break}}),d=o$2(r=>{switch(r.key){case o.Space:r.preventDefault();break}}),P=o$2(r$1=>{var p;r(r$1.currentTarget)||e.disabled||(s?(t({type:0}),(p=l.buttonRef.current)==null||p.focus()):t({type:0}));}),b=useMemo(()=>({open:l.disclosureState===0}),[l]),y=s$2(e,i),a=s?{ref:c,type:y,onKeyDown:D,onClick:P}:{ref:c,id:u,type:y,"aria-expanded":l.disclosureState===0,"aria-controls":l.linkedPanel?l.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return X({ourProps:a,theirProps:T,slot:b,defaultTag:te,name:"Disclosure.Button"})}let le$1="div",oe$2=S$2.RenderStrategy|S$2.Static;function re$1(e,n){let o=I$2(),{id:u=`headlessui-disclosure-panel-${o}`,...T}=e,[l,t]=M$2("Disclosure.Panel"),{close:f}=w("Disclosure.Panel"),s=y$1(n,l.panelRef,P=>{a(()=>t({type:P?4:5}));});useEffect(()=>(t({type:3,panelId:u}),()=>{t({type:3,panelId:null});}),[u,t]);let i=C(),c=(()=>i!==null?(i&d.Open)===d.Open:l.disclosureState===0)(),D=useMemo(()=>({open:l.disclosureState===0,close:f}),[l,f]),d$1={ref:s,id:u};return React__default.createElement(H.Provider,{value:l.panelId},X({ourProps:d$1,theirProps:T,slot:D,defaultTag:le$1,features:oe$2,visible:c,name:"Disclosure.Panel"}))}let se$1=D$1(ee),ue$1=D$1(ne),ie$1=D$1(re$1),ve=Object.assign(se$1,{Button:ue$1,Panel:ie$1});

var he=(u=>(u[u.Open=0]="Open",u[u.Closed=1]="Closed",u))(he||{}),He$1=(e=>(e[e.TogglePopover=0]="TogglePopover",e[e.ClosePopover=1]="ClosePopover",e[e.SetButton=2]="SetButton",e[e.SetButtonId=3]="SetButtonId",e[e.SetPanel=4]="SetPanel",e[e.SetPanelId=5]="SetPanelId",e))(He$1||{});let _e={[0]:t=>{let o={...t,popoverState:u$1(t.popoverState,{[0]:1,[1]:0})};return o.popoverState===0&&(o.__demoMode=!1),o},[1](t){return t.popoverState===1?t:{...t,popoverState:1}},[2](t,o){return t.button===o.button?t:{...t,button:o.button}},[3](t,o){return t.buttonId===o.buttonId?t:{...t,buttonId:o.buttonId}},[4](t,o){return t.panel===o.panel?t:{...t,panel:o.panel}},[5](t,o){return t.panelId===o.panelId?t:{...t,panelId:o.panelId}}},ue=createContext(null);ue.displayName="PopoverContext";function oe$1(t){let o=useContext(ue);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,oe$1),u}return o}let ie=createContext(null);ie.displayName="PopoverAPIContext";function fe(t){let o=useContext(ie);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,fe),u}return o}let Pe$1=createContext(null);Pe$1.displayName="PopoverGroupContext";function Ee(){return useContext(Pe$1)}let re=createContext(null);re.displayName="PopoverPanelContext";function Ge(){return useContext(re)}function Ne$1(t,o){return u$1(o.type,_e,t,o)}let ke="div";function we(t,o){var D;let{__demoMode:u=!1,...R}=t,O=useRef(null),n=y$1(o,T(l=>{O.current=l;})),e=useRef([]),v=useReducer(Ne$1,{__demoMode:u,popoverState:u?0:1,buttons:e,button:null,buttonId:null,panel:null,panelId:null,beforePanelSentinel:createRef(),afterPanelSentinel:createRef()}),[{popoverState:P,button:s,buttonId:I,panel:p,panelId:T$2,beforePanelSentinel:m,afterPanelSentinel:S},i]=v,a=n$1((D=O.current)!=null?D:s),E=useMemo(()=>{if(!s||!p)return !1;for(let K of document.querySelectorAll("body > *"))if(Number(K==null?void 0:K.contains(s))^Number(K==null?void 0:K.contains(p)))return !0;let l=f$2(),F=l.indexOf(s),q=(F+l.length-1)%l.length,W=(F+1)%l.length,z=l[q],be=l[W];return !p.contains(z)&&!p.contains(be)},[s,p]),C=s$5(I),H=s$5(T$2),x=useMemo(()=>({buttonId:C,panelId:H,close:()=>i({type:1})}),[C,H,i]),M=Ee(),h$2=M==null?void 0:M.registerPopover,f=o$2(()=>{var l;return (l=M==null?void 0:M.isFocusWithinPopoverGroup())!=null?l:(a==null?void 0:a.activeElement)&&((s==null?void 0:s.contains(a.activeElement))||(p==null?void 0:p.contains(a.activeElement)))});useEffect(()=>h$2==null?void 0:h$2(x),[h$2,x]);let[y,b]=ae$1(),d$1=j({mainTreeNodeRef:M==null?void 0:M.mainTreeNodeRef,portals:y,defaultContainers:[s,p]});E$1(a==null?void 0:a.defaultView,"focus",l=>{var F,q,W,z;l.target!==window&&l.target instanceof HTMLElement&&P===0&&(f()||s&&p&&(d$1.contains(l.target)||(q=(F=m.current)==null?void 0:F.contains)!=null&&q.call(F,l.target)||(z=(W=S.current)==null?void 0:W.contains)!=null&&z.call(W,l.target)||i({type:1})));},!0),h(d$1.resolveContainers,(l,F)=>{i({type:1}),h$1(F,T$1.Loose)||(l.preventDefault(),s==null||s.focus());},P===0);let L=o$2(l=>{i({type:1});let F=(()=>l?l instanceof HTMLElement?l:"current"in l&&l.current instanceof HTMLElement?l.current:s:s)();F==null||F.focus();}),r=useMemo(()=>({close:L,isPortalled:E}),[L,E]),c=useMemo(()=>({open:P===0,close:L}),[P,L]),B={ref:n};return React__default.createElement(re.Provider,{value:null},React__default.createElement(ue.Provider,{value:v},React__default.createElement(ie.Provider,{value:r},React__default.createElement(c$2,{value:u$1(P,{[0]:d.Open,[1]:d.Closed})},React__default.createElement(b,null,X({ourProps:B,theirProps:R,slot:c,defaultTag:ke,name:"Popover"}),React__default.createElement(d$1.MainTreeNode,null))))))}let Ue="button";function We(t,o$1){let u=I$2(),{id:R=`headlessui-popover-button-${u}`,...O$1}=t,[n$2,e]=oe$1("Popover.Button"),{isPortalled:v}=fe("Popover.Button"),P=useRef(null),s$1=`headlessui-focus-sentinel-${I$2()}`,I=Ee(),p$1=I==null?void 0:I.closeOthers,m=Ge()!==null;useEffect(()=>{if(!m)return e({type:3,buttonId:R}),()=>{e({type:3,buttonId:null});}},[m,R,e]);let[S]=useState(()=>Symbol()),i=y$1(P,o$1,m?null:r=>{if(r)n$2.buttons.current.push(S);else {let c=n$2.buttons.current.indexOf(S);c!==-1&&n$2.buttons.current.splice(c,1);}n$2.buttons.current.length>1&&console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."),r&&e({type:2,button:r});}),a=y$1(P,o$1),E=n$1(P),C=o$2(r=>{var c,B,D;if(m){if(n$2.popoverState===1)return;switch(r.key){case o.Space:case o.Enter:r.preventDefault(),(B=(c=r.target).click)==null||B.call(c),e({type:1}),(D=n$2.button)==null||D.focus();break}}else switch(r.key){case o.Space:case o.Enter:r.preventDefault(),r.stopPropagation(),n$2.popoverState===1&&(p$1==null||p$1(n$2.buttonId)),e({type:0});break;case o.Escape:if(n$2.popoverState!==0)return p$1==null?void 0:p$1(n$2.buttonId);if(!P.current||E!=null&&E.activeElement&&!P.current.contains(E.activeElement))return;r.preventDefault(),r.stopPropagation(),e({type:1});break}}),H=o$2(r=>{m||r.key===o.Space&&r.preventDefault();}),x=o$2(r$1=>{var c,B;r(r$1.currentTarget)||t.disabled||(m?(e({type:1}),(c=n$2.button)==null||c.focus()):(r$1.preventDefault(),r$1.stopPropagation(),n$2.popoverState===1&&(p$1==null||p$1(n$2.buttonId)),e({type:0}),(B=n$2.button)==null||B.focus()));}),M=o$2(r=>{r.preventDefault(),r.stopPropagation();}),h=n$2.popoverState===0,f=useMemo(()=>({open:h}),[h]),y=s$2(t,P),b=m?{ref:a,type:y,onKeyDown:C,onClick:x}:{ref:i,id:n$2.buttonId,type:y,"aria-expanded":n$2.popoverState===0,"aria-controls":n$2.panel?n$2.panelId:void 0,onKeyDown:C,onKeyUp:H,onClick:x,onMouseDown:M},d=n(),L=o$2(()=>{let r=n$2.panel;if(!r)return;function c(){u$1(d.current,{[s.Forwards]:()=>O(r,M$3.First),[s.Backwards]:()=>O(r,M$3.Last)})===N$2.Error&&O(f$2().filter(D=>D.dataset.headlessuiFocusGuard!=="true"),u$1(d.current,{[s.Forwards]:M$3.Next,[s.Backwards]:M$3.Previous}),{relativeTo:n$2.button});}c();});return React__default.createElement(React__default.Fragment,null,X({ourProps:b,theirProps:O$1,slot:f,defaultTag:Ue,name:"Popover.Button"}),h&&!m&&v&&React__default.createElement(c$3,{id:s$1,features:p.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:L}))}let Ke="div",je=S$2.RenderStrategy|S$2.Static;function Ve(t,o){let u=I$2(),{id:R=`headlessui-popover-overlay-${u}`,...O}=t,[{popoverState:n},e]=oe$1("Popover.Overlay"),v=y$1(o),P=C(),s=(()=>P!==null?(P&d.Open)===d.Open:n===0)(),I=o$2(m=>{if(r(m.currentTarget))return m.preventDefault();e({type:1});}),p=useMemo(()=>({open:n===0}),[n]);return X({ourProps:{ref:v,id:R,"aria-hidden":!0,onClick:I},theirProps:O,slot:p,defaultTag:Ke,features:je,visible:s,name:"Popover.Overlay"})}let $e="div",Je=S$2.RenderStrategy|S$2.Static;function Xe(t,o$1){let u=I$2(),{id:R=`headlessui-popover-panel-${u}`,focus:O$1=!1,...n$2}=t,[e,v]=oe$1("Popover.Panel"),{close:P,isPortalled:s$1}=fe("Popover.Panel"),I=`headlessui-focus-sentinel-before-${I$2()}`,p$1=`headlessui-focus-sentinel-after-${I$2()}`,T=useRef(null),m=y$1(T,o$1,f=>{v({type:4,panel:f});}),S=n$1(T);l$3(()=>(v({type:5,panelId:R}),()=>{v({type:5,panelId:null});}),[R,v]);let i=C(),a=(()=>i!==null?(i&d.Open)===d.Open:e.popoverState===0)(),E=o$2(f=>{var y;switch(f.key){case o.Escape:if(e.popoverState!==0||!T.current||S!=null&&S.activeElement&&!T.current.contains(S.activeElement))return;f.preventDefault(),f.stopPropagation(),v({type:1}),(y=e.button)==null||y.focus();break}});useEffect(()=>{var f;t.static||e.popoverState===1&&((f=t.unmount)==null||f)&&v({type:4,panel:null});},[e.popoverState,t.unmount,t.static,v]),useEffect(()=>{if(e.__demoMode||!O$1||e.popoverState!==0||!T.current)return;let f=S==null?void 0:S.activeElement;T.current.contains(f)||O(T.current,M$3.First);},[e.__demoMode,O$1,T,e.popoverState]);let C$1=useMemo(()=>({open:e.popoverState===0,close:P}),[e,P]),H={ref:m,id:R,onKeyDown:E,onBlur:O$1&&e.popoverState===0?f=>{var b,d,L,r,c;let y=f.relatedTarget;y&&T.current&&((b=T.current)!=null&&b.contains(y)||(v({type:1}),((L=(d=e.beforePanelSentinel.current)==null?void 0:d.contains)!=null&&L.call(d,y)||(c=(r=e.afterPanelSentinel.current)==null?void 0:r.contains)!=null&&c.call(r,y))&&y.focus({preventScroll:!0})));}:void 0,tabIndex:-1},x=n(),M=o$2(()=>{let f=T.current;if(!f)return;function y(){u$1(x.current,{[s.Forwards]:()=>{var d;O(f,M$3.First)===N$2.Error&&((d=e.afterPanelSentinel.current)==null||d.focus());},[s.Backwards]:()=>{var b;(b=e.button)==null||b.focus({preventScroll:!0});}});}y();}),h=o$2(()=>{let f=T.current;if(!f)return;function y(){u$1(x.current,{[s.Forwards]:()=>{var B;if(!e.button)return;let b=f$2(),d=b.indexOf(e.button),L=b.slice(0,d+1),c=[...b.slice(d+1),...L];for(let D of c.slice())if(D.dataset.headlessuiFocusGuard==="true"||(B=e.panel)!=null&&B.contains(D)){let l=c.indexOf(D);l!==-1&&c.splice(l,1);}O(c,M$3.First,{sorted:!1});},[s.Backwards]:()=>{var d;O(f,M$3.Previous)===N$2.Error&&((d=e.button)==null||d.focus());}});}y();});return React__default.createElement(re.Provider,{value:R},a&&s$1&&React__default.createElement(c$3,{id:I,ref:e.beforePanelSentinel,features:p.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:M}),X({ourProps:H,theirProps:n$2,slot:C$1,defaultTag:$e,features:Je,visible:a,name:"Popover.Panel"}),a&&s$1&&React__default.createElement(c$3,{id:p$1,ref:e.afterPanelSentinel,features:p.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:h}))}let Ye="div";function qe(t,o){let u=useRef(null),R=y$1(u,o),[O,n]=useState([]),e=y(),v=o$2(i=>{n(a=>{let E=a.indexOf(i);if(E!==-1){let C=a.slice();return C.splice(E,1),C}return a});}),P=o$2(i=>(n(a=>[...a,i]),()=>v(i))),s=o$2(()=>{var E;let i=e$1(u);if(!i)return !1;let a=i.activeElement;return (E=u.current)!=null&&E.contains(a)?!0:O.some(C=>{var H,x;return ((H=i.getElementById(C.buttonId.current))==null?void 0:H.contains(a))||((x=i.getElementById(C.panelId.current))==null?void 0:x.contains(a))})}),I=o$2(i=>{for(let a of O)a.buttonId.current!==i&&a.close();}),p=useMemo(()=>({registerPopover:P,unregisterPopover:v,isFocusWithinPopoverGroup:s,closeOthers:I,mainTreeNodeRef:e.mainTreeNodeRef}),[P,v,s,I,e.mainTreeNodeRef]),T=useMemo(()=>({}),[]),m=t,S={ref:R};return React__default.createElement(Pe$1.Provider,{value:p},X({ourProps:S,theirProps:m,slot:T,defaultTag:Ye,name:"Popover.Group"}),React__default.createElement(e.MainTreeNode,null))}let ze=D$1(we),Qe=D$1(We),Ze=D$1(Ve),et=D$1(Xe),tt$1=D$1(qe),kt=Object.assign(ze,{Button:Qe,Overlay:Ze,Panel:et,Group:tt$1});

function c(a=0){let[l,r]=useState(a),t=f$1(),o=useCallback(e=>{t.current&&r(u=>u|e);},[l,t]),m=useCallback(e=>Boolean(l&e),[l]),s=useCallback(e=>{t.current&&r(u=>u&~e);},[r,t]),g=useCallback(e=>{t.current&&r(u=>u^e);},[r]);return {flags:l,addFlag:o,hasFlag:m,removeFlag:s,toggleFlag:g}}

function l(r){let e={called:!1};return (...t)=>{if(!e.called)return e.called=!0,r(...t)}}

function g(t,...e){t&&e.length>0&&t.classList.add(...e);}function v(t,...e){t&&e.length>0&&t.classList.remove(...e);}function b(t,e){let n=o$3();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:a}=getComputedStyle(t),[u,p]=[m,a].map(l=>{let[r=0]=l.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,T)=>T-i);return r}),o=u+p;if(o!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose();},o),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose();});});let l=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),l());});}else e();return n.add(()=>e()),n.dispose}function M$1(t,e,n,m){let a=n?"enter":"leave",u=o$3(),p=m!==void 0?l(m):()=>{};a==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let o=u$1(a,{enter:()=>e.enter,leave:()=>e.leave}),l$1=u$1(a,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=u$1(a,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v(t,...e.base,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),g(t,...e.base,...o,...r),u.nextFrame(()=>{v(t,...e.base,...o,...r),g(t,...e.base,...o,...l$1),b(t,()=>(v(t,...e.base,...o),g(t,...e.base,...e.entered),p()));}),u.dispose}

function E({immediate:t,container:s,direction:n,classes:u,onStart:a,onStop:c}){let l=f$1(),d=p$1(),e=s$5(n);l$3(()=>{t&&(e.current="enter");},[t]),l$3(()=>{let r=o$3();d.add(r.dispose);let i=s.current;if(i&&e.current!=="idle"&&l.current)return r.dispose(),a.current(e.current),r.add(M$1(i,u.current,e.current==="enter",()=>{r.dispose(),c.current(e.current);})),r.dispose},[n]);}

function S(t=""){return t.split(" ").filter(n=>n.trim().length>1)}let _=createContext(null);_.displayName="TransitionContext";var be=(r=>(r.Visible="visible",r.Hidden="hidden",r))(be||{});function Se(){let t=useContext(_);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}function Ne(){let t=useContext(M);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}let M=createContext(null);M.displayName="NestingContext";function U(t){return "children"in t?U(t.children):t.current.filter(({el:n})=>n.current!==null).filter(({state:n})=>n==="visible").length>0}function oe(t,n){let r=s$5(t),s=useRef([]),y=f$1(),D=p$1(),c=o$2((i,e=j$2.Hidden)=>{let a=s.current.findIndex(({el:o})=>o===i);a!==-1&&(u$1(e,{[j$2.Unmount](){s.current.splice(a,1);},[j$2.Hidden](){s.current[a].state="hidden";}}),D.microTask(()=>{var o;!U(s)&&y.current&&((o=r.current)==null||o.call(r));}));}),x=o$2(i=>{let e=s.current.find(({el:a})=>a===i);return e?e.state!=="visible"&&(e.state="visible"):s.current.push({el:i,state:"visible"}),()=>c(i,j$2.Unmount)}),p=useRef([]),h=useRef(Promise.resolve()),u=useRef({enter:[],leave:[],idle:[]}),v=o$2((i,e,a)=>{p.current.splice(0),n&&(n.chains.current[e]=n.chains.current[e].filter(([o])=>o!==i)),n==null||n.chains.current[e].push([i,new Promise(o=>{p.current.push(o);})]),n==null||n.chains.current[e].push([i,new Promise(o=>{Promise.all(u.current[e].map(([f,P])=>P)).then(()=>o());})]),e==="enter"?h.current=h.current.then(()=>n==null?void 0:n.wait.current).then(()=>a(e)):a(e);}),d=o$2((i,e,a)=>{Promise.all(u.current[e].splice(0).map(([o,f])=>f)).then(()=>{var o;(o=p.current.shift())==null||o();}).then(()=>a(e));});return useMemo(()=>({children:s,register:x,unregister:c,onStart:v,onStop:d,wait:h,chains:u}),[x,c,s,v,d,u,h])}function xe(){}let Pe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function se(t){var r;let n={};for(let s of Pe)n[s]=(r=t[s])!=null?r:xe;return n}function Re(t){let n=useRef(se(t));return useEffect(()=>{n.current=se(t);},[t]),n}let ye="div",ae=S$2.RenderStrategy;function De(t,n){var K,Q;let{beforeEnter:r,afterEnter:s,beforeLeave:y,afterLeave:D,enter:c$1,enterFrom:x,enterTo:p,entered:h,leave:u,leaveFrom:v,leaveTo:d$1,...i}=t,e=useRef(null),a=y$1(e,n),o=(K=i.unmount)==null||K?j$2.Unmount:j$2.Hidden,{show:f,appear:P,initial:T}=Se(),[l,j]=useState(f?"visible":"hidden"),q=Ne(),{register:O,unregister:V}=q;useEffect(()=>O(e),[O,e]),useEffect(()=>{if(o===j$2.Hidden&&e.current){if(f&&l!=="visible"){j("visible");return}return u$1(l,{["hidden"]:()=>V(e),["visible"]:()=>O(e)})}},[l,e,O,V,f,o]);let k=s$5({base:S(i.className),enter:S(c$1),enterFrom:S(x),enterTo:S(p),entered:S(h),leave:S(u),leaveFrom:S(v),leaveTo:S(d$1)}),w=Re({beforeEnter:r,afterEnter:s,beforeLeave:y,afterLeave:D}),G=l$2();useEffect(()=>{if(G&&l==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[e,l,G]);let ue=T&&!P,z=P&&f&&T,Te=(()=>!G||ue?"idle":f?"enter":"leave")(),H=c(0),de=o$2(g=>u$1(g,{enter:()=>{H.addFlag(d.Opening),w.current.beforeEnter();},leave:()=>{H.addFlag(d.Closing),w.current.beforeLeave();},idle:()=>{}})),fe=o$2(g=>u$1(g,{enter:()=>{H.removeFlag(d.Opening),w.current.afterEnter();},leave:()=>{H.removeFlag(d.Closing),w.current.afterLeave();},idle:()=>{}})),A=oe(()=>{j("hidden"),V(e);},q);E({immediate:z,container:e,classes:k,direction:Te,onStart:s$5(g=>{A.onStart(e,g,de);}),onStop:s$5(g=>{A.onStop(e,g,fe),g==="leave"&&!U(A)&&(j("hidden"),V(e));})});let R=i,me={ref:a};return z?R={...R,className:t$1(i.className,...k.current.enter,...k.current.enterFrom)}:(R.className=t$1(i.className,(Q=e.current)==null?void 0:Q.className),R.className===""&&delete R.className),React__default.createElement(M.Provider,{value:A},React__default.createElement(c$2,{value:u$1(l,{["visible"]:d.Open,["hidden"]:d.Closed})|H.flags},X({ourProps:me,theirProps:R,defaultTag:ye,features:ae,visible:l==="visible",name:"Transition.Child"})))}function He(t,n){let{show:r,appear:s=!1,unmount:y=!0,...D}=t,c=useRef(null),x=y$1(c,n);l$2();let p=C();if(r===void 0&&p!==null&&(r=(p&d.Open)===d.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[h,u]=useState(r?"visible":"hidden"),v=oe(()=>{u("hidden");}),[d$1,i]=useState(!0),e=useRef([r]);l$3(()=>{d$1!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),i(!1));},[e,r]);let a=useMemo(()=>({show:r,appear:s,initial:d$1}),[r,s,d$1]);useEffect(()=>{if(r)u("visible");else if(!U(v))u("hidden");else {let T=c.current;if(!T)return;let l=T.getBoundingClientRect();l.x===0&&l.y===0&&l.width===0&&l.height===0&&u("hidden");}},[r,v]);let o={unmount:y},f=o$2(()=>{var T;d$1&&i(!1),(T=t.beforeEnter)==null||T.call(t);}),P=o$2(()=>{var T;d$1&&i(!1),(T=t.beforeLeave)==null||T.call(t);});return React__default.createElement(M.Provider,{value:v},React__default.createElement(_.Provider,{value:a},X({ourProps:{...o,as:Fragment,children:React__default.createElement(le,{ref:x,...o,...D,beforeEnter:f,beforeLeave:P})},theirProps:{},defaultTag:Fragment,features:ae,visible:h==="visible",name:"Transition"})))}function Fe(t,n){let r=useContext(_)!==null,s=C()!==null;return React__default.createElement(React__default.Fragment,null,!r&&s?React__default.createElement(W,{ref:n,...t}):React__default.createElement(le,{ref:n,...t}))}let W=D$1(He),le=D$1(De),Le=D$1(Fe),tt=Object.assign(W,{Child:Le,Root:W});

var Base = React.forwardRef(function (props, ref) {
    var _a = props.sticky, sticky = _a === void 0 ? false : _a, _b = props.fixed, fixed = _b === void 0 ? false : _b, _c = props.appendClassNames, appendClassNames = _c === void 0 ? "" : _c;
    return (React.createElement(kt.Group, __assign({ as: "header", className: (sticky ? "sticky " : "") +
            (fixed ? "fixed " : "") +
            (sticky || fixed ? "top-0 left-0 z-10 " : "relative ") +
            appendClassNames, ref: ref }, props.props), props.children));
});

var Link = React.forwardRef(function (props, ref) {
    var _a = props.hideCrawl, hideCrawl = _a === void 0 ? false : _a;
    var isReactSnap = navigator && navigator.userAgent === "ReactSnap";
    props["hideCrawl"]; var linkProps = __rest(props, ['hideCrawl']);
    var linkComponent = React.createElement(Link$1, __assign({}, linkProps, { ref: ref }), props.children);
    if (!hideCrawl) {
        return linkComponent;
    }
    return React.createElement(React.Fragment, null, !isReactSnap && linkComponent);
});

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && /*#__PURE__*/React__default.createContext(DefaultContext);

var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/React__default.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/React__default.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/React__default.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function HiBars3 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiBars4 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 5.25zm0 4.5A.75.75 0 013.75 9h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 9.75zm0 4.5a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiChevronDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiChevronUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiMagnifyingGlass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiXMark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z","clipRule":"evenodd"},"child":[]}]})(props);
}function HiMiniXMark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"},"child":[{"tag":"path","attr":{"d":"M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"},"child":[]}]})(props);
}

var ButtonType;
(function (ButtonType) {
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
    ButtonType["BUTTON"] = "button";
})(ButtonType || (ButtonType = {}));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["INFO"] = "info";
    ButtonVariant["SUCCESS"] = "success";
    ButtonVariant["DANGER"] = "danger";
    ButtonVariant["WARNING"] = "warning";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["XXLARGE"] = "2xl";
    ButtonSize["XLARGE"] = "xl";
    ButtonSize["LARGE"] = "lg";
    ButtonSize["MEDIUM"] = "md";
    ButtonSize["SMALL"] = "sm";
})(ButtonSize || (ButtonSize = {}));
var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["ALLIEDCONTAINER"] = "acem";
    ButtonTheme["ALLIEDCONTAINER2"] = "acem2";
    ButtonTheme["ALLIEDFOOD"] = "afood";
    ButtonTheme["ALLIEDDEPOT"] = "acds";
    ButtonTheme["WINSPEC"] = "winspec";
    ButtonTheme["AGLOGIS"] = "aglogis";
    ButtonTheme["ACSMARINE"] = "acsm";
})(ButtonTheme || (ButtonTheme = {}));
var themes = new Map();
var acemTheme = new Map();
acemTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acemTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem-red text-acem-white");
acemTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-acem-black border-1 border-acem-black");
acemTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acemTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acemTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acemTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acemTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acemTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acemTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acemTheme.set("disabled-true", "cursor-not-allowed");
acemTheme.set("disabled-false", "cursor-pointer");
var acem2Theme = new Map();
acem2Theme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-satoshi font-medium");
acem2Theme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem2-primary hover:bg-acem2-maroon text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-acem2-white hover:bg-acem2-cloud text-acem2-black border-1 border-acem2-black");
acem2Theme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acem2Theme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acem2Theme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acem2Theme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acem2Theme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acem2Theme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acem2Theme.set("disabled-true", "cursor-not-allowed");
acem2Theme.set("disabled-false", "cursor-pointer");
var afoodTheme = new Map();
afoodTheme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-poppins");
afoodTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-afood-primary border-1 border-transparent hover:bg-white hover:border-afood-primary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-afood-secondary border-1 border-transparent hover:bg-white hover:border-afood-secondary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
afoodTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
afoodTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
afoodTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
afoodTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
afoodTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
afoodTheme.set("disabled-true", "cursor-not-allowed");
afoodTheme.set("disabled-false", "cursor-pointer");
var winspecTheme = new Map();
winspecTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
winspecTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-winspec-primary border-1 border-transparent hover:bg-white text-white hover:text-winspec-primary hover:border-winspec-primary");
winspecTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white border-1 border-black text-black");
winspecTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
winspecTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
winspecTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
winspecTheme.set("size-".concat(ButtonSize.LARGE), "py-2 px-6");
winspecTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
winspecTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
winspecTheme.set("disabled-true", "cursor-not-allowed");
winspecTheme.set("disabled-false", "cursor-pointer");
var aglogisTheme = new Map();
aglogisTheme.set("", "inline-block rounded-2xl ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-open-sans");
aglogisTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-aglogis-primary text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-aglogis-primary");
aglogisTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
aglogisTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
aglogisTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
aglogisTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
aglogisTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
aglogisTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
aglogisTheme.set("disabled-true", "cursor-not-allowed");
aglogisTheme.set("disabled-false", "cursor-pointer");
var acdsTheme = new Map();
acdsTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acdsTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acds-primary text-white hover:bg-white hover:text-acds-primary border-1 border-transparent hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-black hover:bg-acds-primary hover:text-white hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acdsTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acdsTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acdsTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acdsTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acdsTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acdsTheme.set("disabled-true", "cursor-not-allowed");
acdsTheme.set("disabled-false", "cursor-pointer");
var acsmTheme = new Map();
acsmTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-verdana sm:!font-poppins");
acsmTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acsm-primary text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acsmTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-4 sm:px-6 md:px-8 lg:px-10 text-base md:text-xl");
acsmTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-4 sm:px-5 md:px-6 lg:px-9 text-base md:text-lg");
acsmTheme.set("size-".concat(ButtonSize.LARGE), "py-3 px-8");
acsmTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-7");
acsmTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-3 text-sm");
acsmTheme.set("disabled-true", "cursor-not-allowed");
acsmTheme.set("disabled-false", "cursor-pointer");
themes.set(ButtonTheme.ALLIEDCONTAINER, acemTheme);
themes.set(ButtonTheme.ALLIEDCONTAINER2, acem2Theme);
themes.set(ButtonTheme.ALLIEDFOOD, afoodTheme);
themes.set(ButtonTheme.ALLIEDDEPOT, acdsTheme);
themes.set(ButtonTheme.WINSPEC, winspecTheme);
themes.set(ButtonTheme.AGLOGIS, aglogisTheme);
themes.set(ButtonTheme.ACSMARINE, acsmTheme);
var ButtonStyle = /** @class */ (function () {
    function ButtonStyle() {
        this.theme = "";
        this.variant = "";
        this.size = "";
        this.disabled = false;
        this.appendedClassNames = "";
    }
    ButtonStyle.prototype.build = function () {
        var style = "";
        var theme = themes.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("")) {
            style += theme.get("");
        }
        if (theme.has("variant-".concat(this.variant))) {
            style += " " + theme.get("variant-".concat(this.variant));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ButtonStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    ButtonStyle.prototype.setVariant = function (variant) {
        this.variant = variant;
        return this;
    };
    ButtonStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ButtonStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled || false;
        return this;
    };
    ButtonStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ButtonStyle;
}());

var styleBuilder$2 = new ButtonStyle();
var ButtonLink = React.forwardRef(function (props, ref) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.theme, theme = _a === void 0 ? themeCtx.theme || ButtonTheme.ALLIEDCONTAINER : _a, _b = props.variant, variant = _b === void 0 ? ButtonVariant.PRIMARY : _b, _c = props.size, size = _c === void 0 ? ButtonSize.MEDIUM : _c;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder$2.
        setTheme(theme).
        setVariant(variant).
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement(Link, { ref: ref, to: props.to, target: props.target, hideCrawl: props.hideCrawl, className: styleClassNames, style: __assign({ textDecoration: "none" }, props.style), onClick: handleClick }, props.children));
});

function AlliedContainer(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, _b = props.linkItems, linkItems = _b === void 0 ? [] : _b, _c = props.infoItems, infoItems = _c === void 0 ? [] : _c, _d = props.navItems, navItems = _d === void 0 ? [] : _d;
    return (React.createElement(Base, { sticky: props.sticky },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex lg:hidden" },
                React.createElement("div", { className: "bg-white flex items-center justify-between w-full px-6 py-4 md:py-2" },
                    React.createElement("div", null,
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-10" }))),
                    React.createElement(kt, { as: React.Fragment }, function (_a) {
                        var open = _a.open, close = _a.close;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                open ?
                                    React.createElement(HiXMark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                    :
                                        React.createElement(HiBars3, { className: "block h-6 w-6", "aria-hidden": "true" })),
                            React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                React.createElement(kt.Panel, { className: "absolute top-0 left-0 w-full min-h-screen bg-acem-black py-4" },
                                    React.createElement("div", { className: "flex items-center justify-between" },
                                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-52 h-20" })),
                                        React.createElement("div", { className: "px-8" },
                                            React.createElement(kt.Button, { className: "text-acem-red" },
                                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                                React.createElement(HiXMark, { className: "block h-6 w-6", "aria-hidden": "true" })))),
                                    React.createElement("hr", { className: "text-acem-white m-8" }),
                                    React.createElement("div", { className: "px-8" }, linkItems.map(function (menu, i) {
                                        return (React.createElement(Link, { key: "link-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "block no-underline my-2 text-acem-white", onClick: function () { close(); } }, menu.content));
                                    })),
                                    React.createElement("hr", { className: "text-acem-white m-8" }),
                                    React.createElement("div", { className: "px-8" },
                                        React.createElement("div", { className: "flex flex-col gap-4" }, menuItems.map(function (menu, i) {
                                            return (React.createElement(ButtonLink, { key: "menu-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, theme: "acem", variant: "primary", appendClassNames: "text-center", onClick: function () { close(); } }, menu.content));
                                        })))))));
                    }))),
            React.createElement("div", { className: "hidden lg:flex" },
                React.createElement("div", { className: "bg-white flex items-center justify-between gap-6 w-full px-6 py-4 md:py-2" },
                    React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                        React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-10" })),
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("div", { className: "flex items-center justify-between gap-4 py-2 px-4 border-r-1 border-black" }, infoItems.map(function (menu, i) {
                            return (React.createElement(Link, { key: "info-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "text-acem-black font-semibold" }, menu.content));
                        })),
                        React.createElement("div", { className: "flex items-center justify-between gap-4 py-2 px-4" }, menuItems.map(function (menu, i) {
                            return (React.createElement(ButtonLink, { key: "menu-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, theme: "acem", variant: "primary" }, menu.content));
                        })))))),
        navItems.length > 0 &&
            React.createElement("nav", { className: "hidden lg:inline-block w-full bg-acem-black px-6 py-3" },
                React.createElement("ul", { className: "flex flex-wrap justify-center items-center gap-y-2 gap-x-10 font-bold" }, navItems.map(function (menu, i) {
                    return (React.createElement("li", { key: "nav-item-".concat(i) },
                        React.createElement(Link, { to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "block no-underline m-2 text-center text-acem-white" }, menu.content)));
                })))));
}

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const min = Math.min;
const max = Math.max;
const round = Math.round;
const createCoords = v => ({
  x: v,
  y: v
});
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var index$1 = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }

  // biome-ignore lint/suspicious/noSelfCompare: in source
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = React[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : undefined);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  index(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = React[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/React.createContext(null);
const FloatingTreeContext = /*#__PURE__*/React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const endedOrStartedInsideRef = React.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && isElement(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = getComputedStyle$1(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            onOpenChange(false, event.nativeEvent, 'reference-press');
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        onMouseDown() {
          endedOrStartedInsideRef.current = true;
        },
        onMouseUp() {
          endedOrStartedInsideRef.current = true;
        },
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /*#__PURE__*/new Set();
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  var _options$elements2;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  if (process.env.NODE_ENV !== "production") {
    var _options$elements;
    const err = 'Floating UI: Cannot pass a virtual element to the ' + '`elements.reference` option, as it must be a real DOM element. ' + 'Use `refs.setPositionReference` instead.';
    if ((_options$elements = options.elements) != null && _options$elements.reference && !isElement(options.elements.reference)) {
      var _devMessageSet;
      if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(err))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(err);
        console.error(err);
      }
    }
  }
  const [_domReference, setDomReference] = React.useState(null);
  const domReference = ((_options$elements2 = options.elements) == null ? void 0 : _options$elements2.reference) || _domReference;
  const position = useFloating$1(options);
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const onOpenChange = useEffectEvent((open, event, reason) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    unstable_onOpenChange == null || unstable_onOpenChange(open, event, reason);
  });
  const domReferenceRef = React.useRef(null);
  const dataRef = React.useRef({});
  const events = React.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = React.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getReferenceProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'reference'), deps);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getFloatingProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'floating'), deps);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
  const getItemProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  propsList.map(key => key == null ? void 0 : key.item));
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

var ContainerSize;
(function (ContainerSize) {
    ContainerSize["FULL"] = "full";
    ContainerSize["XXXLARGE"] = "3xl";
    ContainerSize["XXLARGE"] = "2xl";
    ContainerSize["XLARGE"] = "xl";
    ContainerSize["LARGE"] = "lg";
    ContainerSize["MEDIUM"] = "md";
    ContainerSize["SMALL"] = "sm";
})(ContainerSize || (ContainerSize = {}));
var defaultTheme = new Map();
defaultTheme.set("size-".concat(ContainerSize.FULL), "w-full px-3 mx-auto");
defaultTheme.set("size-".concat(ContainerSize.XXXLARGE), "w-full px-3 mx-auto bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XXLARGE), "w-full px-3 mx-auto bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XLARGE), "w-full px-3 mx-auto bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.LARGE), "w-full px-3 mx-auto bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.MEDIUM), "w-full px-3 mx-auto bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.SMALL), "w-full px-3 mx-auto bs-sm:max-w-bs-sm bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
var ContainerStyle = /** @class */ (function () {
    function ContainerStyle() {
        this.size = "";
        this.appendedClassNames = "";
    }
    ContainerStyle.prototype.build = function () {
        var style = "";
        if (defaultTheme.has("size-".concat(this.size))) {
            style += defaultTheme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ContainerStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ContainerStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ContainerStyle;
}());

var styleBuilder$1 = new ContainerStyle();
function Container(props) {
    var _a = props.size, size = _a === void 0 ? ContainerSize.MEDIUM : _a;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder$1.
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement("div", { onClick: handleClick, className: styleClassNames, style: props.style }, props.children));
}

function AlliedContainer2(props) {
    var _a = props.linkItems, linkItems = _a === void 0 ? [] : _a, _b = props.menuItems, menuItems = _b === void 0 ? [] : _b;
    var _c = useFloating({
        placement: "bottom",
    }), refs = _c.refs, context = _c.context;
    var dismiss = useDismiss(context);
    var getReferenceProps = useInteractions([
        dismiss,
    ]).getReferenceProps;
    return (React.createElement(Base, { ref: refs.setReference, props: getReferenceProps(), sticky: props.sticky, appendClassNames: "font-satoshi" },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex xl:hidden" },
                React.createElement("div", { className: "bg-white flex items-center justify-between w-full px-3 py-4 md:py-2 z-10" },
                    React.createElement("div", { className: "flex flex-row justify-between gap-2" },
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-30 h-10" }))),
                    React.createElement("div", { className: "flex flex-row justify-center items-center gap-2" },
                        React.createElement(kt, null, function (_a) {
                            var open = _a.open, close = _a.close;
                            return (React.createElement(React.Fragment, null,
                                open && React.createElement("div", { className: "fixed inset-0 bg-black opacity-30" }),
                                React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                    React.createElement("span", { className: "sr-only" }, "open menu"),
                                    open ?
                                        React.createElement(HiMiniXMark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                        :
                                            React.createElement(HiBars4, { className: "block h-6 w-6", "aria-hidden": "true" })),
                                React.createElement(kt.Panel, { className: "absolute top-0 left-0 w-full h-screen bg-acem2-cloud px-3 py-4 md:py-2 z-10 overflow-y-auto" },
                                    React.createElement("div", { className: "flex flex-col gap-10" },
                                        React.createElement("div", { className: "flex flex-row justify-between items-center gap-2" },
                                            React.createElement(Link, { to: props.logoUrl, className: "no-underline text-sm" },
                                                React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-30 h-10" })),
                                            React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                                open ?
                                                    React.createElement(HiMiniXMark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                                    :
                                                        React.createElement(HiBars4, { className: "block h-6 w-6", "aria-hidden": "true" }))),
                                        linkItems.length > 0 &&
                                            React.createElement("ul", { className: "flex flex-col gap-6 md:gap-8 text-center" }, linkItems.map(function (linkMenu, i) {
                                                return (React.createElement("li", { key: "link-item-mobile-".concat(i) }, linkMenu.items && linkMenu.items.length > 0 ?
                                                    React.createElement(ve, null, function (_a) {
                                                        var open = _a.open;
                                                        return (React.createElement("div", { className: "w-full flex flex-col gap-4" },
                                                            React.createElement(ve.Button, { className: "flex flex-row justify-center items-center gap-2 text-xl font-medium text-acem2-black hover:text-acem2-maroon" },
                                                                React.createElement("span", null, linkMenu.content),
                                                                open ?
                                                                    React.createElement(HiChevronUp, { className: "block h-4 w-4", "aria-hidden": "true" })
                                                                    :
                                                                        React.createElement(HiChevronDown, { className: "block h-4 w-4", "aria-hidden": "true" })),
                                                            React.createElement(ve.Panel, { as: "ul", className: "flex flex-col gap-4" }, linkMenu.items &&
                                                                React.createElement("div", { className: "grid grid-cols-1 gap-2" }, linkMenu.items.map(function (linkItem, j) {
                                                                    return (React.createElement("div", { key: "heading-item-mobile-".concat(i, "-").concat(j), className: "flex flex-col gap-4" }, linkItem.to ?
                                                                        React.createElement(kt.Button, { as: Link, to: linkItem.to, target: linkItem.target, hideCrawl: linkItem.hideCrawl, className: "no-underline block text-acem2-black hover:text-acem2-maroon" }, linkItem.content)
                                                                        :
                                                                            React.createElement("span", { className: "block text-acem2-black" }, linkItem.content)));
                                                                })))));
                                                    })
                                                    :
                                                        React.createElement(Link, { to: linkMenu.to, target: linkMenu.target, hideCrawl: linkMenu.hideCrawl, className: "block no-underline text-xl font-medium text-acem2-black hover:text-acem2-maroon", onClick: function () { close(); } }, linkMenu.content)));
                                            })),
                                        menuItems.length > 0 &&
                                            React.createElement("div", { className: "flex flex-col gap-4 md:gap-6 px-8 xs:px-2 justify-center items-center text-center" }, menuItems.map(function (menuItem, i) {
                                                return (React.createElement(React.Fragment, { key: "menu-item-mobile-".concat(i) },
                                                    React.createElement(ButtonLink, { theme: "acem2", to: menuItem.to, target: menuItem.target, hideCrawl: menuItem.hideCrawl, appendClassNames: "w-4/5 md:w-64 !font-black", onClick: function () { close(); } }, menuItem.content)));
                                            }))))));
                        })))),
            React.createElement("div", { className: "hidden xl:flex" },
                React.createElement(Container, { size: "full", appendClassNames: "bg-white" },
                    React.createElement("div", { className: "flex items-center justify-between gap-2 w-full md:px-4 py-4" },
                        React.createElement("div", { className: "flex flex-row justify-between gap-2 divide-x-2 divide-black" },
                            React.createElement(Link, { to: props.logoUrl, className: "no-underline text-sm px-2" },
                                React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-30 h-12" }))),
                        linkItems.length > 0 &&
                            React.createElement(kt.Group, { className: "flex flex-row items-center justify-between gap-6 2xl:gap-12 3xl:gap-20 p-2" }, linkItems.map(function (linkMenu, i) {
                                return (React.createElement(kt, { key: "link-item-desktop-".concat(i), className: "text-lg" }, function (_a) {
                                    var open = _a.open, close = _a.close;
                                    return (linkMenu.items && linkMenu.items.length > 0 ?
                                        React.createElement(SubmenuItem, { i: i, linkMenu: linkMenu, open: open })
                                        :
                                            React.createElement(Link, { to: linkMenu.to, target: linkMenu.target, hideCrawl: linkMenu.hideCrawl, className: "flex flex-row gap-1 hover:text-acem2-maroon", onClick: function () { close(); } }, linkMenu.content));
                                }));
                            })),
                        menuItems.length > 0 &&
                            React.createElement("div", { className: "flex flex-row gap-4" }, menuItems.map(function (menuItem, i) {
                                return (React.createElement(React.Fragment, { key: "menu-item-desktop-".concat(i) },
                                    React.createElement(ButtonLink, { theme: "acem2", to: menuItem.to, target: menuItem.target, appendClassNames: "!font-black", hideCrawl: menuItem.hideCrawl }, menuItem.content)));
                            }))))))));
}
function SubmenuItem(props) {
    var i = props.i, open = props.open, linkMenu = props.linkMenu;
    var _a = useFloating({
        placement: "bottom-start",
    }), refs = _a.refs, floatingStyles = _a.floatingStyles, context = _a.context;
    var dismiss = useDismiss(context);
    var _b = useInteractions([
        dismiss,
    ]), getReferenceProps = _b.getReferenceProps, getFloatingProps = _b.getFloatingProps;
    return (React.createElement(React.Fragment, null,
        React.createElement(kt.Button, __assign({ ref: refs.setReference }, getReferenceProps(), { className: "flex flex-row justify-center items-center gap-2 text-acem2-black hover:text-acem2-maroon text-center" }),
            React.createElement("span", null, linkMenu.content),
            open ?
                React.createElement(HiChevronUp, { className: "block h-4 w-4", "aria-hidden": "true" })
                :
                    React.createElement(HiChevronDown, { className: "block h-4 w-4", "aria-hidden": "true" })),
        React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
            React.createElement(kt.Panel, __assign({ className: "w-full !top-2 bg-acem2-cloud z-10 p-4 rounded-md shadow-lg ring-1 ring-black ring-opacity-5", ref: refs.setFloating, style: __assign(__assign({}, floatingStyles), { maxWidth: "300px" }) }, getFloatingProps()), linkMenu.items && linkMenu.items.length > 0 &&
                React.createElement("div", { className: "grid grid-cols-1 gap-2" }, linkMenu.items.map(function (linkItem, j) {
                    return (React.createElement("div", { key: "sublink-item-desktop-".concat(i, "-").concat(j), className: "flex flex-col gap-4" }, linkItem.to ?
                        React.createElement("div", null,
                            React.createElement(kt.Button, { as: Link, to: linkItem.to, target: linkItem.target, hideCrawl: linkItem.hideCrawl, className: "no-underline text-lg text-acem2-black hover:text-acem2-maroon" }, linkItem.content))
                        :
                            React.createElement("span", { className: "text-lg text-acem2-black" }, linkItem.content)));
                }))))));
}

function AlliedFood(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a;
    var _b = useFloating({
        placement: "bottom",
    }), refs = _b.refs, context = _b.context, floatingStyles = _b.floatingStyles;
    var dismiss = useDismiss(context);
    var _c = useInteractions([
        dismiss,
    ]), getReferenceProps = _c.getReferenceProps, getFloatingProps = _c.getFloatingProps;
    return (React.createElement(Base, { ref: refs.setReference, props: getReferenceProps(), sticky: props.sticky },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex lg:hidden" },
                React.createElement("div", { className: "bg-white w-full flex items-center justify-between px-6 py-4 md:py-2" },
                    React.createElement("div", null,
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-10" }))),
                    React.createElement(kt, { as: React.Fragment }, function (_a) {
                        var open = _a.open, close = _a.close;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                open ?
                                    React.createElement(HiXMark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                    :
                                        React.createElement(HiBars3, { className: "block h-6 w-6", "aria-hidden": "true" })),
                            React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                React.createElement(kt.Panel, __assign({ className: "w-full min-h-full z-10 p-2 space-y-1 bg-afood-secondary", ref: refs.setFloating, style: __assign({}, floatingStyles) }, getFloatingProps()),
                                    React.createElement("div", { className: "flex flex-col gap-2" }, menuItems.map(function (menu, i) {
                                        return (React.createElement(Link, { key: "menu-item-mobile-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "text-base text-black hover:text-white hover:bg-gray-700 font-semibold no-underline block px-3 py-2 rounded-md", onClick: function () { close(); } }, menu.content));
                                    }))))));
                    }))),
            React.createElement("div", { className: "hidden lg:flex" },
                React.createElement("div", { className: "bg-white w-full flex items-center justify-center mx-auto gap-6 px-6 py-4" },
                    React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                        React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-10" })),
                    React.createElement("div", { className: "flex items-center justify-between gap-3 py-2 px-6 border-1 border-afood-secondary rounded-lg" }, menuItems.map(function (menu, i) {
                        return (React.createElement(Link, { key: "menu-item-desktop-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "no-underline px-3 py-2 rounded-md text-sm text-black ease-out duration-500 font-semibold font-montserrat hover:bg-afood-secondary" }, menu.content));
                    })),
                    React.createElement(ButtonLink, { to: props.contactUrl, theme: "afood", variant: "secondary", size: "md" }, props.contactLabel))))));
}

function Winspec(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, _b = props.linkItems, linkItems = _b === void 0 ? [] : _b;
    return (React.createElement(Base, { sticky: props.sticky },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex lg:hidden" },
                React.createElement("div", { className: "bg-white flex items-center justify-between w-full px-6 py-4 md:py-2" },
                    React.createElement("div", { className: "flex justify-center items-center w-full" },
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-48 h-10" }))),
                    React.createElement(kt, { as: React.Fragment }, function (_a) {
                        var open = _a.open, close = _a.close;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                open ?
                                    React.createElement(HiXMark, { className: "block h-8 w-8", "aria-hidden": "true" })
                                    :
                                        React.createElement(HiBars3, { className: "block h-8 w-8", "aria-hidden": "true" })),
                            React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                React.createElement(kt.Panel, { className: "absolute top-0 left-0 w-full min-h-screen bg-white py-4" },
                                    React.createElement("div", { className: "flex justify-end items-center" },
                                        React.createElement("div", { className: "px-8" },
                                            React.createElement(kt.Button, { className: "text-black" },
                                                React.createElement("span", { className: "sr-only" }, "open menu"),
                                                React.createElement(HiXMark, { className: "block h-8 w-8", "aria-hidden": "true" })))),
                                    React.createElement("div", { className: "flex flex-col justify-center items-center" },
                                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-52 h-14" })),
                                        React.createElement("h2", { className: "text-xl font-light" }, "Sister Company of Allied")),
                                    React.createElement("div", { className: "px-8 py-4" },
                                        React.createElement("div", { className: "flex flex-col justify-center items-center gap-1" }, linkItems.map(function (menu, i) {
                                            return (React.createElement(Link, { key: "link-item-mobile-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "block no-underline my-2 text-black", onClick: function () { return close(); } }, menu.content));
                                        }))),
                                    React.createElement("div", { className: "px-8 py-4" },
                                        React.createElement("div", { className: "flex flex-col gap-4" }, menuItems.map(function (menu, i) {
                                            return (React.createElement(ButtonLink, { key: "menu-item-mobile-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, theme: "winspec", variant: "primary", appendClassNames: "text-center", onClick: function () { return close(); } }, menu.content));
                                        })))))));
                    }))),
            React.createElement("div", { className: "hidden lg:flex" },
                React.createElement("div", { className: "bg-white flex items-center justify-between gap-2 lg:gap-4 w-full px-4 md:px-6 lg:px-24 3xl:px-64 py-4 md:py-2" },
                    React.createElement("div", { className: "flex items-center justify-between gap-4" },
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "h-10" })),
                        React.createElement("div", { className: "flex items-center justify-between gap-4 lg:gap-6 py-2 px-4" }, linkItems.map(function (menu, i) {
                            return (React.createElement(Link, { key: "link-item-desktop-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, className: "text-black" }, menu.content));
                        }))),
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("div", { className: "flex items-center justify-between gap-2 lg:gap-4 py-2 lg:px-4" }, menuItems.map(function (menu, i) {
                            return (React.createElement(ButtonLink, { key: "menu-item-desktop-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, theme: "winspec", variant: "primary", size: "lg" }, menu.content));
                        }))))))));
}

// THIS FILE IS AUTO GENERATED
function FaBars (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"},"child":[]}]})(props);
}function FaChevronDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"},"child":[]}]})(props);
}function FaChevronUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"},"child":[]}]})(props);
}function FaMagnifyingGlass (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"},"child":[]}]})(props);
}function FaXmark (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 384 512"},"child":[{"tag":"path","attr":{"d":"M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"},"child":[]}]})(props);
}

function DropdownItem(props) {
    return (React.createElement("div", { className: "block rounded-md px-4 py-2 hover:bg-gray-100 cursor-pointer" }, props.children));
}

var DropdownContainer = React.forwardRef(function (props, ref) {
    var appendClassNames = props.appendClassNames, children = props.children, otherProps = __rest(props, ["appendClassNames", "children"]);
    return (React.createElement("div", __assign({ ref: ref }, otherProps, { className: "p-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 " +
            appendClassNames }), children));
});

var Dropdown = function (props) {
    var _a = props.open, open = _a === void 0 ? false : _a;
    var _b = props.children || {}, toggler = _b.toggler, _c = _b.items, items = _c === void 0 ? [] : _c;
    var _d = useFloating({
        placement: "bottom-start",
        open: open,
        onOpenChange: function (open) {
            props.onOpenChange && props.onOpenChange({
                open: open
            });
        }
    }), refs = _d.refs, floatingStyles = _d.floatingStyles, context = _d.context;
    var dismiss = useDismiss(context);
    var _e = useInteractions([
        dismiss,
    ]), getReferenceProps = _e.getReferenceProps, getFloatingProps = _e.getFloatingProps;
    return (React.createElement("div", null,
        React.createElement("div", __assign({ ref: refs.setReference }, getReferenceProps()), toggler),
        open &&
            React.createElement(Dropdown.Container, __assign({ ref: refs.setFloating, style: floatingStyles }, getFloatingProps()), items.map(function (item, i) {
                return (React.createElement(Dropdown.Item, { key: "dropdown-item-".concat(i) }, item));
            }))));
};
Dropdown.Item = DropdownItem;
Dropdown.Container = DropdownContainer;

function Aglogis(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a;
    var _b = React.useState(menuItems.map(function (menu) {
        return __assign(__assign({}, menu), { selected: false });
    })), menu = _b[0], setMenu = _b[1];
    var _c = useFloating({
        placement: "bottom",
    }), refs = _c.refs, context = _c.context, floatingStyles = _c.floatingStyles;
    var dismiss = useDismiss(context);
    var _d = useInteractions([
        dismiss,
    ]), getReferenceProps = _d.getReferenceProps, getFloatingProps = _d.getFloatingProps;
    var toggleMenu = function (position) {
        setMenu(function (prevMenu) {
            return prevMenu.map(function (menu, i) {
                return __assign(__assign({}, menu), { selected: position === i ? !menu.selected : menu.selected });
            });
        });
    };
    var closeMenu = function () {
        setMenu(function (prevMenu) {
            return prevMenu.map(function (menu) {
                return __assign(__assign({}, menu), { selected: false });
            });
        });
    };
    return (React.createElement(Base, { ref: refs.setReference, props: getReferenceProps(), sticky: props.sticky },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex lg:hidden" },
                React.createElement("div", { className: "bg-white flex items-center justify-between w-full px-6 py-4 md:py-2 border-b-7 border-aglogis-red" },
                    React.createElement("div", { className: "flex flex-row gap-4" },
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-30 h-10" })),
                        React.createElement(kt, { as: React.Fragment }, function (_a) {
                            var open = _a.open, close = _a.close;
                            return (React.createElement(React.Fragment, null,
                                React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                    React.createElement("span", { className: "sr-only" }, "open menu"),
                                    open ?
                                        React.createElement(HiXMark, { className: "block h-8 w-8", "aria-hidden": "true" })
                                        :
                                            React.createElement(HiBars3, { className: "block h-8 w-8", "aria-hidden": "true" })),
                                React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                    React.createElement(kt.Panel, __assign({ className: "w-full z-10 p-2 space-y-1 bg-white flex flex-col items-center", ref: refs.setFloating, style: __assign(__assign({}, floatingStyles), { maxWidth: "800px" }) }, getFloatingProps()), menu.map(function (mainMenu, i) {
                                        return (React.createElement(React.Fragment, { key: "menu-item-mobile-".concat(i) }, mainMenu.items && mainMenu.items.length > 0 ?
                                            React.createElement(Dropdown, { open: mainMenu.selected, onOpenChange: function (_a) {
                                                    var open = _a.open;
                                                    setMenu(function (prevMenu) {
                                                        return prevMenu.map(function (menu, j) {
                                                            return __assign(__assign({}, menu), { selected: i === j ? !open : menu.selected });
                                                        });
                                                    });
                                                } }, {
                                                toggler: React.createElement(React.Fragment, null,
                                                    React.createElement("button", { className: "flex flex-row justify-center items-center gap-2 text-xl font-open-sans font-bold no-underline block px-3 py-2 rounded-md", onClick: function () { return toggleMenu(i); } },
                                                        React.createElement("span", { className: "text-black" }, mainMenu.content),
                                                        mainMenu.selected ?
                                                            React.createElement(FaChevronUp, { className: "block h-5 w-5 text-aglogis-primary", "aria-hidden": "true" })
                                                            :
                                                                React.createElement(FaChevronDown, { className: "block h-5 w-5 text-aglogis-primary", "aria-hidden": "true" }))),
                                                items: mainMenu.items.map(function (submenu) {
                                                    return (React.createElement(Link, { to: submenu.to, target: submenu.target, hideCrawl: submenu.hideCrawl, onClick: function () {
                                                            closeMenu();
                                                            close();
                                                        } }, submenu.content));
                                                })
                                            })
                                            :
                                                React.createElement(Link, { to: mainMenu.to, target: mainMenu.target, hideCrawl: mainMenu.hideCrawl, className: "flex flex-row gap-1 text-xl text-black font-open-sans font-bold no-underline block px-3 py-2 rounded-md", onClick: function () {
                                                        closeMenu();
                                                        close();
                                                    } }, mainMenu.content)));
                                    })))));
                        })),
                    props.rightChildren)),
            React.createElement("div", { className: "hidden lg:flex" },
                React.createElement("div", { className: "bg-white flex items-center justify-between gap-6 w-full px-6 py-4 md:py-4 border-b-7", style: { borderColor: "#EC2330" } },
                    React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                        React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-30 h-10" })),
                    React.createElement("div", { className: "flex items-center justify-between gap-4 lg:!gap-6 3xl:!gap-16 py-2 px-4 font-open-sans" }, menu.map(function (mainMenu, i) {
                        return (React.createElement(React.Fragment, { key: "menu-item-".concat(i) }, mainMenu.items && mainMenu.items.length > 0 ?
                            React.createElement(Dropdown, { open: mainMenu.selected, onOpenChange: function (_a) {
                                    var open = _a.open;
                                    setMenu(function (prevMenu) {
                                        return prevMenu.map(function (menu, j) {
                                            return __assign(__assign({}, menu), { selected: i === j ? !open : menu.selected });
                                        });
                                    });
                                } }, {
                                toggler: React.createElement(React.Fragment, null,
                                    React.createElement("button", { className: "flex flex-row jsutify-center items-center gap-2 font-bold text-xl", onClick: function () { return toggleMenu(i); } },
                                        React.createElement("span", { className: "text-black" }, mainMenu.content),
                                        mainMenu.selected ?
                                            React.createElement(FaChevronUp, { className: "block h-5 w-5 text-aglogis-primary", "aria-hidden": "true" })
                                            :
                                                React.createElement(FaChevronDown, { className: "block h-5 w-5 text-aglogis-primary", "aria-hidden": "true" }))),
                                items: mainMenu.items.map(function (submenu, j) {
                                    return (React.createElement(Link, { key: "submenu-item-".concat(j), to: submenu.to, target: submenu.target, hideCrawl: submenu.hideCrawl, onClick: function () {
                                            closeMenu();
                                        } }, submenu.content));
                                })
                            })
                            :
                                React.createElement(Link, { to: mainMenu.to, target: mainMenu.target, hideCrawl: mainMenu.hideCrawl, className: "flex flex-row gap-1 font-bold text-xl", onClick: function () {
                                        closeMenu();
                                    } }, mainMenu.content)));
                    })),
                    props.rightChildren)))));
}

function AlliedDepot(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, _b = props.linkItems, linkItems = _b === void 0 ? [] : _b;
    return (React.createElement(Base, null,
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex lg:hidden" },
                React.createElement(Container, { size: "full", appendClassNames: "bg-transparent" },
                    React.createElement("div", { className: "flex items-center justify-between w-full px-6 py-4 md:py-2" },
                        React.createElement("div", null,
                            React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                                React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-full h-14" }))),
                        React.createElement(kt, { as: React.Fragment }, function (_a) {
                            var open = _a.open, close = _a.close;
                            return (React.createElement(React.Fragment, null,
                                React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md text-zinc-500 border-1 border-zinc-500" },
                                    React.createElement("span", { className: "sr-only" }, "open menu"),
                                    open ?
                                        React.createElement(HiXMark, { className: "block w-7 h-7", "aria-hidden": "true" })
                                        :
                                            React.createElement(HiBars3, { className: "block w-7 h-7", "aria-hidden": "true" })),
                                React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                    React.createElement(kt.Panel, { className: "absolute top-0 right-0 w-5/6 min-h-screen bg-zinc-800 p-4", style: { maxWidth: "400px" } },
                                        React.createElement("div", { className: "flex justify-between items-center mb-10" },
                                            React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                                                React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-52 h-20" })),
                                            React.createElement("div", { className: "" },
                                                React.createElement(kt.Button, { className: "text-white" },
                                                    React.createElement("span", { className: "sr-only" }, "open menu"),
                                                    React.createElement(HiXMark, { className: "block w-7 h-7", "aria-hidden": "true" })))),
                                        React.createElement("div", { className: "flex flex-col gap-4 my-4" }, linkItems.map(function (menu, i) {
                                            return (React.createElement(Link, { key: "link-item-mobile-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, "aria-label": menu.label, className: "block no-underline text-white font-bold", onClick: function () { close(); } }, menu.content));
                                        })),
                                        React.createElement("div", { className: "flex flex-col gap-4" }, menuItems.map(function (menu, i) {
                                            return (React.createElement(ButtonLink, { key: "menu-item-mobile-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, "aria-label": menu.label, theme: "acds", variant: "primary", appendClassNames: "text-center", onClick: function () { close(); } }, menu.content));
                                        }))))));
                        })))),
            React.createElement("div", { className: "hidden lg:flex" },
                React.createElement(Container, { size: "full", appendClassNames: "bg-transparent" },
                    React.createElement("div", { className: "flex justify-start items-center gap-10 w-full p-6 md:py-2" },
                        React.createElement(Link, { to: props.logoUrl, className: "no-underline rounded-md text-sm" },
                            React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-full h-14" })),
                        React.createElement("div", { className: "flex justify-between items-center w-full" },
                            React.createElement("div", { className: "flex justify-start items-center gap-10" }, linkItems.map(function (menu, i) {
                                return (React.createElement(Link, { key: "link-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, "aria-label": menu.label, className: "text-white font-bold" }, menu.content));
                            })),
                            React.createElement("div", { className: "flex justify-start items-center gap-2 xl:gap-5" }, menuItems.map(function (menu, i) {
                                return (React.createElement(ButtonLink, { key: "menu-item-".concat(i), to: menu.to, target: menu.target, hideCrawl: menu.hideCrawl, "aria-label": menu.label, theme: "acds", variant: "primary", size: "lg" }, menu.content));
                            })))))))));
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
freeGlobal || freeSelf || Function('return this')();

var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

// src/useEventListener/useEventListener.ts
function useEventListener(eventName, handler, element, options) {
  const savedHandler = useRef(handler);
  useIsomorphicLayoutEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    const targetElement = (element == null ? void 0 : element.current) ?? window;
    if (!(targetElement && targetElement.addEventListener))
      return;
    const listener = (event) => {
      savedHandler.current(event);
    };
    targetElement.addEventListener(eventName, listener, options);
    return () => {
      targetElement.removeEventListener(eventName, listener, options);
    };
  }, [eventName, element, options]);
}

// src/useOnClickOutside/useOnClickOutside.ts
function useOnClickOutside(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
  useEventListener(
    eventType,
    (event) => {
      const target = event.target;
      if (!target || !target.isConnected) {
        return;
      }
      const isOutside = Array.isArray(ref) ? ref.filter((r) => Boolean(r.current)).every((r) => r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
      if (isOutside) {
        handler(event);
      }
    },
    void 0,
    eventListenerOptions
  );
}

var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize["XLARGE"] = "xl";
    SpinnerSize["LARGE"] = "lg";
    SpinnerSize["MEDIUM"] = "md";
    SpinnerSize["SMALL"] = "sm";
    SpinnerSize["TINY"] = "xs";
})(SpinnerSize || (SpinnerSize = {}));
var SpinnerVariant;
(function (SpinnerVariant) {
    SpinnerVariant["PRIMARY"] = "primary";
    SpinnerVariant["SECONDARY"] = "secondary";
    SpinnerVariant["INFO"] = "info";
    SpinnerVariant["SUCCESS"] = "success";
    SpinnerVariant["DANGER"] = "danger";
    SpinnerVariant["WARNING"] = "warning";
})(SpinnerVariant || (SpinnerVariant = {}));
var theme = new Map();
theme.set("container", "animate-spin border-[4px] border-current border-t-transparent rounded-full");
theme.set("size-".concat(SpinnerSize.XLARGE), "w-36 h-36");
theme.set("size-".concat(SpinnerSize.LARGE), "w-24 h-24");
theme.set("size-".concat(SpinnerSize.MEDIUM), "w-16 h-16");
theme.set("size-".concat(SpinnerSize.SMALL), "w-10 h-10");
theme.set("size-".concat(SpinnerSize.TINY), "w-4 h-4");
theme.set("variant-".concat(SpinnerVariant.PRIMARY), "text-gray-700");
theme.set("variant-".concat(SpinnerVariant.SECONDARY), "text-white");
theme.set("variant-".concat(SpinnerVariant.INFO), "text-blue-500");
theme.set("variant-".concat(SpinnerVariant.SUCCESS), "text-green-500");
theme.set("variant-".concat(SpinnerVariant.DANGER), "text-rose-500");
theme.set("variant-".concat(SpinnerVariant.WARNING), "text-amber-500");
var SpinnerStyle = /** @class */ (function () {
    function SpinnerStyle() {
        this.variant = "";
        this.size = "";
        this.appendedClassNames = "";
    }
    SpinnerStyle.prototype.buildContainer = function () {
        var style = "";
        if (theme.has("container")) {
            style += theme.get("container");
        }
        if (theme.has("variant-".concat(this.variant))) {
            style += " " + theme.get("variant-".concat(this.variant));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    SpinnerStyle.prototype.setVariant = function (variant) {
        this.variant = variant;
        return this;
    };
    SpinnerStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    SpinnerStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return SpinnerStyle;
}());

var styleBuilder = new SpinnerStyle();
function Spinner(props) {
    var _a = props.labeled, labeled = _a === void 0 ? false : _a, _b = props.label, label = _b === void 0 ? "Loading..." : _b, _c = props.appendClassNames, appendClassNames = _c === void 0 ? "" : _c, _d = props.size, size = _d === void 0 ? SpinnerSize.MEDIUM : _d, _e = props.variant, variant = _e === void 0 ? SpinnerVariant.PRIMARY : _e;
    var containerClass = styleBuilder
        .setSize(size)
        .setVariant(variant)
        .appendClassNames(appendClassNames)
        .buildContainer();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex flex-col items-center justify-center text-center" },
            React.createElement("div", { "aria-label": "loading", className: containerClass },
                React.createElement("span", { className: "sr-only" }, "...")),
            labeled &&
                React.createElement("p", { className: "animate-pulse my-2" }, label))));
}

function AlliedMarine(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, _b = props.searchLoading, searchLoading = _b === void 0 ? false : _b, _c = props.searchShow, searchShow = _c === void 0 ? false : _c, _d = props.searchItems, searchItems = _d === void 0 ? [] : _d, _e = props.suggestionItems, suggestionItems = _e === void 0 ? [] : _e, _f = props.onSearch, onSearch = _f === void 0 ? function () { } : _f, _g = props.onSearchClose, onSearchClose = _g === void 0 ? function () { } : _g, _h = props.onSelectItem, onSelectItem = _h === void 0 ? function () { } : _h;
    var _j = React.useState(true), overlay = _j[0], setOverlay = _j[1];
    var _k = useFloating({
        placement: "bottom",
    }), refs = _k.refs, context = _k.context, floatingStyles = _k.floatingStyles;
    var dismiss = useDismiss(context);
    var _l = useInteractions([
        dismiss,
    ]), getReferenceProps = _l.getReferenceProps, getFloatingProps = _l.getFloatingProps;
    return (React.createElement(Base, { ref: refs.setReference, props: getReferenceProps(), sticky: props.sticky, appendClassNames: "font-verdana sm:font-poppins" },
        React.createElement("div", { className: "w-full h-fit" },
            React.createElement("div", { className: "flex xl:hidden" },
                overlay &&
                    React.createElement("div", { className: "fixed inset-0 bg-black opacity-30" }),
                React.createElement("div", { className: "bg-white w-full border-b-4 border-acsm-red py-4 z-10" },
                    React.createElement(Container, { size: "md" },
                        React.createElement("div", { className: "flex items-center justify-between" },
                            React.createElement("div", { className: "flex flex-row justify-between gap-2 divide-x-2 divide-black" },
                                props.logoUrl ?
                                    React.createElement(Link, { to: props.logoUrl, className: "no-underline text-sm px-2" },
                                        React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" }))
                                    :
                                        React.createElement("div", { className: "px-2" },
                                            React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" })),
                                React.createElement("div", { className: "flex flex-row items-end pl-2" }, props.sublogoUrl ?
                                    React.createElement(Link, { to: props.sublogoUrl, className: "no-underline text-sm px-2" },
                                        React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" }))
                                    :
                                        React.createElement("div", { className: "px-2" },
                                            React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" })))),
                            React.createElement("div", { className: "flex flex-row justify-center items-center gap-2" },
                                React.createElement(kt, null, function (_a) {
                                    var open = _a.open, close = _a.close;
                                    return (React.createElement(React.Fragment, null,
                                        React.useEffect(function () {
                                            setOverlay(open);
                                        }, [open]),
                                        React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md", onClick: function () {
                                                onSearchClose && onSearchClose();
                                            } },
                                            React.createElement("span", { className: "sr-only" }, "open search"),
                                            open ?
                                                React.createElement(FaXmark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                                :
                                                    React.createElement(FaMagnifyingGlass, { className: "block h-6 w-6", "aria-hidden": "true" })),
                                        React.createElement(kt.Panel, __assign({ className: "w-full bg-white z-10 p-6", ref: refs.setFloating, style: __assign({}, floatingStyles) }, getFloatingProps()),
                                            React.createElement(SearchBox, { searchLoading: searchLoading, searchShow: searchShow, searchItems: searchItems, suggestionItems: suggestionItems, onSelectItem: function () {
                                                    close();
                                                    onSelectItem && onSelectItem();
                                                }, onSearch: onSearch }))));
                                }),
                                React.createElement(kt, null, function (_a) {
                                    var open = _a.open, close = _a.close;
                                    return (React.createElement(React.Fragment, null,
                                        React.useEffect(function () {
                                            setOverlay(open);
                                        }, [open]),
                                        React.createElement(kt.Button, { className: "inline-flex items-center justify-center p-2 rounded-md" },
                                            React.createElement("span", { className: "sr-only" }, "open menu"),
                                            open ?
                                                React.createElement(FaXmark, { className: "block h-6 w-6", "aria-hidden": "true" })
                                                :
                                                    React.createElement(FaBars, { className: "block h-6 w-6", "aria-hidden": "true" })),
                                        React.createElement(kt.Panel, __assign({ className: "absolute top-[84px] right-0 w-5/6 h-screen bg-white z-10 p-6", ref: refs.setFloating }, getFloatingProps()), menuItems.length > 0 &&
                                            React.createElement("ul", { className: "flex flex-col gap-4" }, menuItems.map(function (mainMenu, i) {
                                                return (React.createElement("li", { key: "menu-item-mobile-".concat(i) }, mainMenu.items && mainMenu.items.length > 0 ?
                                                    React.createElement(ve, null, function (_a) {
                                                        var open = _a.open;
                                                        return (React.createElement("div", { className: "w-full flex flex-col gap-4" },
                                                            React.createElement(ve.Button, { className: "flex flex-row justify-between items-center gap-2 hover:text-acsm-primary" },
                                                                React.createElement("span", null, mainMenu.content),
                                                                open ?
                                                                    React.createElement(FaChevronUp, { className: "block h-4 w-4", "aria-hidden": "true" })
                                                                    :
                                                                        React.createElement(FaChevronDown, { className: "block h-4 w-4", "aria-hidden": "true" })),
                                                            React.createElement(ve.Panel, { as: "ul", className: "flex flex-col gap-4 ml-8" }, mainMenu.items &&
                                                                React.createElement("div", { className: "grid grid-cols-1 gap-2" }, mainMenu.items.map(function (headingMenu, j) {
                                                                    return (React.createElement("div", { key: "heading-item-mobile-".concat(i, "-").concat(j), className: "flex flex-col gap-4" },
                                                                        headingMenu.to ?
                                                                            React.createElement(kt.Button, { as: Link, to: headingMenu.to, target: headingMenu.target, hideCrawl: headingMenu.hideCrawl, className: "no-underline block text-acsm-red hover:text-acsm-primary" }, headingMenu.content)
                                                                            :
                                                                                React.createElement("span", { className: "block text-acsm-red" }, headingMenu.content),
                                                                        React.createElement("hr", { className: "border text-gray-500" }),
                                                                        headingMenu.items &&
                                                                            React.createElement("div", { className: "flex flex-col gap-4 ml-8" }, headingMenu.items.map(function (submenu, k) {
                                                                                return (React.createElement(Link, { key: "submenu-item-mobile-".concat(i, "-").concat(j, "-").concat(k), to: submenu.to, target: submenu.target, hideCrawl: submenu.hideCrawl, className: "hover:text-acsm-primary", onClick: function () { close(); } }, submenu.content));
                                                                            }))));
                                                                })))));
                                                    })
                                                    :
                                                        React.createElement(Link, { to: mainMenu.to, target: mainMenu.target, hideCrawl: mainMenu.hideCrawl, className: "block no-underline hover:text-acsm-primary", onClick: function () { close(); } }, mainMenu.content)));
                                            })))));
                                })))))),
            React.createElement("div", { className: "hidden xl:flex" },
                React.createElement("div", { className: "bg-white w-full border-b-3 border-acsm-red" },
                    React.createElement(Container, { size: "md" },
                        React.createElement("div", { className: "flex items-center justify-between gap-2 w-full py-4" },
                            React.createElement("div", { className: "flex flex-row justify-between gap-2 xl:gap-6 divide-x-2 divide-black" },
                                props.logoUrl ?
                                    React.createElement(Link, { to: props.logoUrl, className: "flex flex-row items-center gap-2 px-2 no-underline text-sm" },
                                        React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" }),
                                        props.logoDescription &&
                                            React.createElement("span", { className: "font-verdana text-xs text-[#231F20] hidden xl:block" }, props.logoDescription))
                                    :
                                        React.createElement("div", { className: "flex flex-row items-center gap-2 px-2" },
                                            React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" }),
                                            props.logoDescription &&
                                                React.createElement("span", { className: "font-verdana text-xs text-[#231F20] hidden xl:block" }, props.logoDescription)),
                                props.sublogoUrl ?
                                    React.createElement(Link, { to: props.sublogoUrl, className: "flex flex-row items-end gap-2 pl-4 pr-2 no-underline text-sm" },
                                        React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" }),
                                        props.sublogoDescription &&
                                            React.createElement("span", { className: "text-xs hidden xl:block" }, props.sublogoDescription))
                                    :
                                        React.createElement("div", { className: "flex flex-row items-end gap-2 pl-4 pr-2" },
                                            React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" }),
                                            props.sublogoDescription &&
                                                React.createElement("span", { className: "text-xs hidden xl:block" }, props.sublogoDescription))),
                            menuItems.length > 0 &&
                                React.createElement(kt.Group, { className: "flex flex-row items-center justify-between gap-4 xl:gap-16 p-2" }, menuItems.map(function (mainMenu, i) {
                                    return (React.createElement(kt, { key: "menu-item-desktop-".concat(i), className: "text-lg" }, function (_a) {
                                        var open = _a.open, close = _a.close;
                                        return (mainMenu.items && mainMenu.items.length > 0 ?
                                            React.createElement(React.Fragment, null,
                                                React.createElement(kt.Button, { className: "flex flex-row justify-center items-center gap-2 hover:text-acsm-primary text-center" },
                                                    React.createElement("span", null, mainMenu.content),
                                                    open ?
                                                        React.createElement(FaChevronUp, { className: "block h-4 w-4", "aria-hidden": "true" })
                                                        :
                                                            React.createElement(FaChevronDown, { className: "block h-4 w-4", "aria-hidden": "true" })),
                                                React.createElement(tt, { as: React.Fragment, enter: "transition duration-500 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-500 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" },
                                                    React.createElement(kt.Panel, __assign({ className: "w-full !left-64 !top-2 bg-white z-10 p-7 rounded-md shadow-lg ring-1 ring-black ring-opacity-5", ref: refs.setFloating, style: __assign(__assign({}, floatingStyles), { maxWidth: "800px" }) }, getFloatingProps()), mainMenu.items && mainMenu.items.length > 0 &&
                                                        React.createElement("div", { className: "grid grid-cols-1 gap-2" }, mainMenu.items.map(function (headingMenu, j) {
                                                            return (React.createElement("div", { key: "heading-item-desktop-".concat(i, "-").concat(j), className: "flex flex-col gap-4" },
                                                                headingMenu.to ?
                                                                    React.createElement("div", null,
                                                                        React.createElement(kt.Button, { as: Link, to: headingMenu.to, target: headingMenu.target, hideCrawl: headingMenu.hideCrawl, className: "no-underline text-lg text-acsm-red hover:text-acsm-primary" }, headingMenu.content))
                                                                    :
                                                                        React.createElement("span", { className: "text-lg text-acsm-red" }, headingMenu.content),
                                                                React.createElement("hr", { className: "border text-gray-500" }),
                                                                headingMenu.items &&
                                                                    React.createElement("div", { className: "grid grid-cols-3 gap-2" }, headingMenu.items.map(function (subMenu, k) {
                                                                        return (React.createElement(React.Fragment, { key: "submenu-item-desktop-".concat(i, "-").concat(j, "-").concat(k) },
                                                                            React.createElement("div", { className: "rounded-md py-4 px-2 hover:bg-acsm-primary cursor-pointer flex justify-center items-center text-center" },
                                                                                React.createElement(Link, { to: subMenu.to, target: subMenu.target, hideCrawl: subMenu.hideCrawl, onClick: function () { close(); } }, subMenu.content))));
                                                                    }))));
                                                        })))))
                                            :
                                                React.createElement(Link, { to: mainMenu.to, target: mainMenu.target, hideCrawl: mainMenu.hideCrawl, className: "flex flex-row gap-1 hover:text-acsm-primary", onClick: function () { close(); } }, mainMenu.content));
                                    }));
                                })),
                            React.createElement("div", null,
                                React.createElement(SearchBox, { searchLoading: searchLoading, searchShow: searchShow, searchItems: searchItems, suggestionItems: suggestionItems, onSearch: onSearch })))))))));
}
function InputSearch(props) {
    var _a = props.required, required = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.readOnly, readOnly = _c === void 0 ? false : _c, _d = props.className, className = _d === void 0 ? "w-full p-2 border rounded-tl rounded-bl" : _d;
    var handleInputClick = function (e) {
        props.onInputClick && props.onInputClick(e);
    };
    var handleInput = function (e) {
        props.onInput && props.onInput(e);
    };
    var handleChange = function (e) {
        props.onChange && props.onChange(e);
    };
    var handleBlur = function (e) {
        props.onBlur && props.onBlur(e);
    };
    var handleSubmit = function () {
        props.onSubmit && props.onSubmit();
    };
    return (React.createElement("div", { className: "flex flex-row" },
        React.createElement("input", { type: "search", id: props.id, name: props.name, placeholder: props.placeholder, style: props.style, className: className, defaultValue: props.defaultValue, value: props.value, required: required, disabled: disabled, readOnly: readOnly, onInput: handleInput, onChange: handleChange, onBlur: handleBlur, onClick: handleInputClick }),
        React.createElement("div", { className: "p-3 bg-acsm-primary rounded-tr-3xl rounded-br-3xl cursor-pointer", onClick: handleSubmit },
            React.createElement(HiMagnifyingGlass, { className: "w-6 h-6 text-black" }))));
}
function SearchBox(props) {
    var _a = props.searchLoading, searchLoading = _a === void 0 ? false : _a, _b = props.searchShow, searchShow = _b === void 0 ? false : _b, _c = props.searchItems, searchItems = _c === void 0 ? [] : _c, _d = props.suggestionItems, suggestionItems = _d === void 0 ? [] : _d, _e = props.onSearch, onSearch = _e === void 0 ? function () { } : _e, _f = props.onSelectItem, onSelectItem = _f === void 0 ? function () { } : _f;
    var containerRef = React.useRef(null);
    var _g = React.useState(""), keyword = _g[0], setKeyword = _g[1];
    var _h = React.useState({
        show: searchShow,
        loading: searchLoading,
        items: searchItems
    }), search = _h[0], setSearch = _h[1];
    var _j = React.useState({
        show: false,
        items: suggestionItems
    }), suggestion = _j[0], setSuggestion = _j[1];
    var _k = useFloating({
        placement: "bottom-start",
    }), refs = _k.refs, floatingStyles = _k.floatingStyles, context = _k.context;
    var dismiss = useDismiss(context);
    var _l = useInteractions([
        dismiss,
    ]), getReferenceProps = _l.getReferenceProps, getFloatingProps = _l.getFloatingProps;
    function selectSuggestion(keyword) {
        setKeyword(keyword);
        onSearch && onSearch({
            keyword: keyword
        });
    }
    function selectSearch() {
        setSuggestion(function (prevState) {
            return __assign(__assign({}, prevState), { show: false });
        });
        setSearch(function (prevState) {
            return __assign(__assign({}, prevState), { show: false });
        });
        onSelectItem && onSelectItem();
    }
    // @note: 
    // don't call search callback here to avoid clearing the input trigger the search
    var handleInputClick = function () {
        if (keyword.length === 0) {
            setSuggestion(function (prevState) {
                return __assign(__assign({}, prevState), { show: true });
            });
            return;
        }
    };
    var handleInputChange = function (e) {
        var keyword = e.currentTarget.value;
        setKeyword(keyword);
        if (keyword.length === 0) {
            setSuggestion(function (prevState) {
                return __assign(__assign({}, prevState), { show: true });
            });
            setSearch(function (prevState) {
                return __assign(__assign({}, prevState), { show: false });
            });
        }
        onSearch && onSearch({
            keyword: keyword
        });
    };
    var handleInputSubmit = function () {
        onSearch && onSearch({
            keyword: keyword
        });
    };
    useOnClickOutside(containerRef, function (e) {
        setSuggestion(function (prevState) {
            return __assign(__assign({}, prevState), { show: false });
        });
        setSearch(function (prevState) {
            return __assign(__assign({}, prevState), { show: false });
        });
    });
    React.useEffect(function () {
        setSuggestion(function (prevState) {
            return __assign(__assign({}, prevState), { items: suggestionItems });
        });
    }, [suggestionItems]);
    React.useEffect(function () {
        setSearch(function (prevState) {
            return __assign(__assign({}, prevState), { show: searchShow, loading: searchLoading, items: searchItems });
        });
    }, [searchShow, searchLoading, searchItems]);
    return (React.createElement("div", { ref: containerRef },
        React.createElement("div", __assign({ className: "w-full", ref: refs.setReference }, getReferenceProps()),
            React.createElement(InputSearch, { className: "min-w-[260px] w-full px-5 py-3 rounded-tl-3xl rounded-bl-3xl bg-acsm-primary placeholder:text-gray-800 text-black", placeholder: "What are you looking for?", value: keyword, onChange: handleInputChange, onInputClick: handleInputClick, onSubmit: handleInputSubmit }),
            (suggestion.show || search.show) &&
                React.createElement("div", __assign({ className: "!top-2 w-full bg-white rounded-md p-4 shadow-lg ring-1 ring-black ring-opacity-5", ref: refs.setFloating, style: __assign(__assign({}, floatingStyles), { maxWidth: "300px" }) }, getFloatingProps()),
                    (suggestion.show && !search.show) &&
                        React.createElement(React.Fragment, null,
                            React.createElement("p", { className: "text-gray-500 text-xs font-semibold mb-1" }, "Most popular searches:"),
                            suggestion.items && suggestion.items.length > 0 &&
                                React.createElement("ul", { className: "flex flex-row gap-x-6 text-sm" }, suggestion.items.map(function (suggestion, i) {
                                    return (React.createElement(React.Fragment, { key: "suggestion-item-".concat(i) },
                                        React.createElement("li", { className: "cursor-pointer", onClick: function () { selectSuggestion(suggestion); } }, suggestion)));
                                }))),
                    search.show &&
                        React.createElement(React.Fragment, null,
                            search.loading &&
                                React.createElement("div", null,
                                    React.createElement(Spinner, { size: "xs", label: "Loading...", labeled: true })),
                            !search.loading &&
                                React.createElement(React.Fragment, null,
                                    search.items.length === 0 &&
                                        React.createElement("p", { className: "text-gray-500 text-xs font-semibold mb-1" }, "There's no item found, try another keyword"),
                                    search.items.length > 0 &&
                                        React.createElement("ul", { className: "flex flex-col gap-x-6" }, search.items.map(function (searchItem, i) {
                                            return (React.createElement(React.Fragment, { key: "search-item-".concat(i) },
                                                React.createElement("li", { className: "cursor-pointer" },
                                                    React.createElement(Link, { to: searchItem.url, className: "no-underline hover:text-acsm-primary", onClick: function () {
                                                            selectSearch();
                                                        } }, searchItem.name))));
                                        }))))))));
}

var Header = function (props) {
    return React.createElement(Base, __assign({}, props));
};
Header.AlliedContainer = AlliedContainer;
Header.AlliedContainer2 = AlliedContainer2;
Header.AlliedFood = AlliedFood;
Header.Winspec = Winspec;
Header.Aglogis = Aglogis;
Header.AlliedDepot = AlliedDepot;
Header.AlliedMarine = AlliedMarine;

export { Header };
